<template>
  <div 
    class="cpt-voice-panel w-fit absolute z-[102] left-[66px] bottom-0" 
    :class="{ 
      'custom': !is_login,
      'in-home-page': isInHomePage,
      'module-expend': needExpend,
      'module-expend-animation': inHomeExpendAnimation === 'expend',
      'module-collapse-animation': inHomeExpendAnimation === 'collapse',
      'has-top-panel': showAdvertisementPanel || is_show_game_display_block,
    }" 
    :style="wrapperStyle"
    @mouseenter='handleMouseEnterWrapper'
    @mouseleave='handleMouseLeaveWrapper'
    v-remind-to-login
  >
    <AdvertisementPanel 
      ref="advertisement" 
      v-if="showAdvertisementPanel"
      v-show="!hide_advertisement_panel"
      :style="{
        minWidth: $route.name === 'friends' ? '300px' : '',
      }"
      @hover="readAdvertisement = true" 
      @mouseLeave="handleMouseLeaveWrapper"
      @close="handleMouseLeaveWrapper"
    />
    <GameDisplayBlock 
      v-if="checkIsPlayingOfficialGame"
      v-show="is_show_game_display_block" 
      ref="game-display" 
      :cptWidth="cptWidth"
      :style="{
        minWidth: $route.name === 'friends' ? '300px' : '',
      }"
      :class="{'flat-top' : showAdvertisementPanel}"
      :gameDisplayInfo="gameDisplayInfo"
      @expend="handleUpdateExpend"
    />
    <div 
      class="voice-panel-container" 
      @contextmenu="handleVoicePanelContextMenu"
      v-show="showFullPanel"
      :style="{
        width: cptWidth + 'px',
        background: emphasize_show_theme_bg_color,
        minWidth: $route.name === 'friends' ? '300px' : '',
      }"
      >
      <VerifiedNotice v-if="cur_channel_others_bilibili_living && !user_verified"></VerifiedNotice>
      <template>
        <div class="top-wrapper only-text-wrapper" v-if="!cur_channel_data.channel_id && only_text_channel_data.channel_id">
          <div class="channel-info">
            <div
              class="channel-name text-ellipse"
              v-emoji-html="{text: only_text_channel_data.channel_name, className: 'w-[14px]'}"
            ></div>
            <div class="audio-member-count text-ellipse" v-if="only_text_channel_data.members?.length">当前 {{ only_text_channel_data.members.length }} 人正在语音</div>
          </div>
          <Button
            class="join-channel-btn"
            text="加入语音"  
            @click="handleJoinChannel"
          />
        </div>
        <div class="top-wrapper" v-else-if="cur_channel_data.channel_id">
          <template v-if="cur_channel_data.refuse_user_audio">
            <div class="refuse-switch-wrapper bg-[#ED7900] h-[81px] m-[-13px_-16px_-9px] p-[0_16px] relative">
              <div class="top flex justify-between">
                <div class="text mt-[13px] font-bold text-[14px] leading-[18px] tracking-[0.01em] text-white">
                  <p>已在另一设备开麦，</p>
                  <p>是否切换到当前设备</p>
                </div>
                <div class="switch-btn w-[45px] h-[30px] mt-[18px] mb-[1px] bg-white rounded-[4px] text-[#ED7900] text-center leading-[29px] font-bold text-[12px] tracking-[0.01em] cursor-pointer" @click="snatchMicHandler()">切换</div>
              </div>
              <div class="room-name !text-op-5" @click="jumpRoom">
                <span>
                  {{ cur_channel_data.channel_name }} / {{ cur_channel_data.room_name }}
                </span>
                <i class="iconfont icon-arrow-left"></i>
              </div>
              <i class="close-icon iconfont icon-close-bold w-[22px] h-[22px] p-[5px] !text-[12px] text-op-4 absolute right-[-2px] top-[-2px] cursor-pointer" @click="exitChannelHandler()"></i>
            </div>
            <div class="split"></div>
          </template>
          <template v-else-if="cur_channel_data.channel_id">
            <div class="room-info flex items-center">
              <div class="left w-0 flex-1 items-center">
                <div class="connect-state h-[18px] font-bold text-[14px] leading-[18px] tracking-[0.01em] whitespace-nowrap text-bd-tx flex items-center" :class="'signal-' + (!isVoiceLoading && networkQuality)">
                  <ChatCircleLoading v-if="isVoiceLoading"></ChatCircleLoading>

                  <Tooltip v-else>
                    <div class="signal">
                      <div class="reg r1"></div>
                      <div class="reg r2"></div>
                      <div class="reg r3"></div>
                    </div>
                    <template #content>
                      <div class="network-stats-tooltip" :class="'stats-' + networkQuality">
                        <p>延迟: <span>{{ statisticsQuality.ping }}ms</span></p>
                        <p>丢包: <span>{{ statisticsQuality.loss }}%</span></p>
                      </div>
                    </template>
                  </Tooltip>

                  <!-- <span>
                    {{ audioStateText }}
                  </span> -->
                  <span class="time-remain" 
                    :style="{
                      width: (remainHour.length + remainMin.length + remainSec.length) * 10 + 'px'
                    }"
                    >
                      {{
                        channel_connecting ?
                          '' :
                          ' ' + (remainHour ? remainHour + ':' : '') + remainMin + ':' + remainSec
                      }}
                  </span>
                  <KbpsSpan :kbps="cur_channel_data.audio_bitrate" class="kbps-icon"></KbpsSpan>
                  <AvLineIcon 
                    class="pannel-av-line-icon" 
                    :api_type="cur_channel_data.api_type" 
                    :width="16" 
                    :fontSize="22"
                    v-if="global_switches.show_av_line_icon"></AvLineIcon>
                </div>
                <div class="room-name" @click="jumpRoom">
                  <span
                    v-emoji-html="{text: cur_channel_data.room_name + ' / ' + cur_channel_data.channel_name, className: 'w-[12px]'}"
                  ></span>
                  <i class="iconfont icon-arrow-left"></i>
                </div>
              </div>
              <div 
                class="minimal" 
                v-if="!!user_account_settings.show_minimal_chat && !isLowLevelElectronClient" 
                v-tooltip="{ text: '切换至极简模式，体验超低占用'}"
                @click="openMinimalChat">
                <i class="iconfont icon-pip"></i>
              </div>
              <div class="hangup">
                <i class="iconfont icon-hangup" @click="handleHangUp"></i>
              </div>
            </div>
            <div class="addition-operate">
              <Tooltip 
                placement="top" 
                :popperClass="screenshareTooltipConfig.popperClass" 
                :manual="screenshareTooltipConfig.manual" 
                :show="screenshareTooltipConfig.show"
                :disable="screenshareTooltipConfig.disable"
              >
                <div slot="content">
                  <p v-html="screenshareTooltipConfig.text"></p>
                </div>
                <div class="operate-block"
                  :class="[{
                    'screen-active': my_screen_sharing,
                    'icon-flash': my_screen_sharing,
                    disabled: screenShareDisableText,
                  }, STABLE_ANIMATION_CLASS_NAME]" @click="handleCickOperate('screen')">
                  <i class="iconfont" :class="my_screen_sharing ? 'icon-pcoff': 'icon-pcshare'"></i>
                  <span>{{my_screen_sharing ? '停止共享' : '屏幕共享'}}</span>
                </div>
              </Tooltip>

              <div 
                v-if="showScreenShareRewardTip"
                class="cpt-get-screen-share-tips w-[322px] pt-0 pb-[16px] px-[16px] rounded-[8px] flex flex-col items-start shadow-[0px_3px_15px_0px_rgba(0,0,0,0.35)] bg-bg-ln-3 absolute bottom-[40px] left-[-68px] z-[2]"
              >
                <div class="avatar-box w-[82px] h-[82px] p-[4px] mx-auto mt-[-35px] rounded-[50%] bg-[#FFF983]">
                  <Avatar 
                    class="avatar" 
                    :img="getScreenShareData?.avatar" 
                    :avatar_decoration="getScreenShareData?.avatar_decoration || {}" 
                    :hideOnline="true"
                  />
                </div>
                <p class="w-full mt-[14px] text-wh-0 text-center text-[16px] font-bold leading-[22px]">恭喜你已获得 邀请好礼！<br>可免费使用 屏幕共享720P {{getScreenShareData?.award_time}}天</p>
                <p class="w-full mt-[6px] text-wh-0 text-center text-[13px] leading-[20px]" v-if="getScreenShareData?.another">用户 {{getScreenShareData?.another?.nickname}} 成功邀请了你</p>
                <div class="w-full h-[42px] mt-[12px] flex items-center justify-center">
                  <div @click="closeGetScreenTips(false)" class="w-[114px] h-[42px] mr-[10px] rounded-[5px] flex justify-center items-center bg-wh-2 text-wh-5 text-center text-[14px] cursor-pointer">之后再说</div>
                  <div @click="closeGetScreenTips(true)" class="w-[114px] h-[42px] mr-[10px] rounded-[5px] flex justify-center items-center bg-wh-0 text-ss-fl font-bold text-center text-[14px] cursor-pointer">来看看吧</div>
                </div>
              </div>

              <div
                v-if="showRecordOperationTip" 
                class="record-operation-tip w-[322px] rounded-[8px] bg-fl-pp fixed bottom-[109px] left-[60px] flex flex-col items-start gap-[12px] shadow-[0px_3px_15px_0px_rgba(0,0,0,0.35)] bg-fl-pp p-[16px]">
                <div class="record-operation-info flex items-start gap-[10px] self-stretch">
                  <div class="record-operation-info-icon" :class="recordOperationConfig.iconColor">
                    <i class="iconfont" :class="recordOperationConfig.icon"></i>
                  </div>
                  <div class="record-operation-info-detail flex flex-col items-start gap-[6px] flex-[1_0_0]">
                    <div class="record-operation-info-detail-title self-stretch text-tx-1 text-[16px] font-bold leading-[22px] tracking-[0.16px]">{{ recordOperationConfig.title }}</div>
                    <div class="record-operation-info-detail-desc self-stretch text-tx-2 text-[13px] leading-[20px] tracking-[0.13px]">{{ recordOperationConfig.desc }}</div>
                  </div>
                </div>
                <div class="record-operation-btns flex justify-start items-center flex-row-reverse gap-[10px] self-stretch pt-[12px]">
                  <div 
                    @click="recordOperationConfig.confirmCB"
                    class="record-operation-btn-confirm pointer flex h-[30px] min-w-[46px] flex-col justify-center items-center gap-[10px] bg-bd-fl px-[10px] py-0 rounded-[4px] text-wh-0 text-center text-[12px] leading-[16px] tracking-[0.12px]">
                    {{ recordOperationConfig.confirm }}
                  </div>
                  <div 
                    @click="handleClearShowRecordOperationTip"
                    class="record-operation-btn-cancel pointer flex h-[30px] min-w-[46px] flex-col justify-center items-center gap-[10px] bg-fl-btn px-[10px] py-0 rounded-[4px] text-tx-1 text-center text-[12px] leading-[16px] tracking-[0.12px]">
                    我知道了
                  </div>
                </div>
              </div>


              <Tooltip
                placement="top"
                popperClass="record-tooltip"
                :disable="isClient && !is_recording"
                :key="`${is_recording ? 0 : 1}:${recordingTime}`"
              >
                <div slot="content">
                  <div class="record-tooltip-title">
                    {{ recordTooltipConfig.text }}
                  </div>
                  <div class="record-tooltip-desc" :key="recordingTime">
                    {{ recordTooltipConfig.desc }}
                  </div>
                </div>
                <div 
                  class="operate-block only-icon operate-block-record" 
                  :class="{
                    'record-active': is_recording,
                  }" 
                  v-report.click="{
                    event_type: 'record'
                  }"
                  ref="record-box"
                  @click="handleCickOperate('record')"
                >
                  <i class="iconfont" :class="[!is_recording ? 'icon-record-circle' : 'icon-stop-circle']"></i>
                </div>
              </Tooltip>

              <Tooltip 
                placement="top" 
                :popperClass="bgmTooltipConfig.popperClass" 
                :manual="bgmTooltipConfig.manual" 
                :show="bgmTooltipConfig.show"
              >
                <div slot="content">
                  <p v-html="bgmTooltipConfig.text"></p>
                </div>
                <div 
                  class="operate-block only-icon" 
                  :class="{
                    'bgm-active': bgm_state.isStart,
                    disabled: bgmDisableText,
                  }" 
                  @click="handleCickOperate('bgm')"
                  v-report.click="{
                    event_type: 'bgm'
                  }"
                >
                  <img :class="STABLE_ANIMATION_CLASS_NAME" v-if="bgm_state.isStart"
                    :src="bgm_state.image || DEFAULT_BGM_IMAGE" />
                  <i v-else class="iconfont icon-music"></i>
                </div>
              </Tooltip>

              <div 
                v-tooltip="{ text: laughterDisableText || '语音包' }" 
                class="operate-block only-icon" 
                :class="{
                  'laughter-active': showLaughterSelector,
                  disabled: laughterDisableText
                }" 
                @mousedown="handleCickOperate('laughter')"
                v-report.click="{
                    event_type: 'laughter'
                  }"
                >
                <i class="iconfont icon-soundboard"></i>
              </div>
            </div>
            <div class="split"></div>
          </template>
        </div>

        <div class="bottom-wrapper p-[13px_16px_15px] h-[63px] flex items-center justify-between -mr-[1px]">
          <div 
            class="user-info flex relative w-0 flex-1 cursor-pointer" 
            ref="user-box" 
            @contextmenu.prevent.stop="mineContextMenuHandler"
            @click.stop="userCardMenu($event, 'mine', user_info)" 
            v-if="is_login || isCheckingLogin"
            >
            <Avatar 
              class="avatar flex-shrink-0 mr-[8px]" 
              :img="user_info.avatar || infoPreLoad('avatar') || CHAT_LOGO_IMG" 
              :onlineState="isCheckingLogin ? 1 : online_state "
              :avatar_decoration="user_info.avatar_decoration || {}"
            />
            <div class="user-text w-[calc(100%-40px)]">
              <p 
                class="name font-bold text-[12px] leading-[16px] tracking-[0.01em] text-tx-1 mb-[2px] mt-[2px] max-w-full whitespace-nowrap text-ellipsis overflow-hidden"
              >
                {{ user_info.nickname || infoPreLoad('nickname') }}
              </p>
              <div class="hover-roll">
                <p class="hover-text state">ID: {{ user_info.user_id }}</p>
                <p 
                  class="default-text state"
                  :class="{ 
                    'online': online_state == 1, 
                    'other-state': online_state == 5 || online_state == 6 
                  }"
                  v-html="mineStateText"
                >
                </p>
              </div>
            </div>
          </div>
          <div class="visitor-info flex relative w-0 flex-1 cursor-pointer items-center" v-else>
            <img class="static-logo w-[32px] h-[32px] flex-shrink-0 mr-[8px] rounded-full" src="@/assets/images/chat-logo.png" />
            <div class="visitor-text w-[calc(100%-40px)] h-full text-[12px] text-tx-1 leading-[16px]">
              注册/登录
            </div>
          </div>
          <div class="track-wrapper flex items-center flex-shrink-0 relative" v-if="!isInHomePage || afterExpended">
            <!-- ai降噪图标 -->
            <div class="icon-container" ref="ai-denoiser-box" @mouseenter="hidenPover">
              <div 
                class="icon" 
                @click="openAIDenoiserConfig"
                >
                <div class="ai-icon">
                  <div :class="[setting_data.AI_denoiser_V2 ? 'ln-bg' : 'cl-bg']"></div>
                  <svg 
                    width="26" 
                    height="26" 
                    viewBox="0 0 26 26" 
                    fill="none" 
                    xmlns="http://www.w3.org/2000/svg"
                    >
                    <g clip-path="url(#clip0_10957_241283)">
                      <path 
                        :style="{ fill: emphasize_show_theme_bg_color }"
                        d="M26 0H0V26H26V0ZM19 4.75C19 4.33579 19.3358 4 19.75 4C20.1642 4 20.5 4.33579 20.5 4.75V5.5H21.25C21.6642 5.5 22 5.83579 22 6.25C22 6.66421 21.6642 7 21.25 7H20.5V7.75C20.5 8.16421 20.1642 8.5 19.75 8.5C19.3358 8.5 19 8.16421 19 7.75V7H18.25C17.8358 7 17.5 6.66421 17.5 6.25C17.5 5.83579 17.8358 5.5 18.25 5.5H19V4.75ZM13 6.25C13.6213 6.25 14.125 6.75368 14.125 7.375V18.625C14.125 19.2463 13.6213 19.75 13 19.75C12.3787 19.75 11.875 19.2463 11.875 18.625V7.375C11.875 6.75368 12.3787 6.25 13 6.25ZM9.625 8.5C10.2463 8.5 10.75 9.00368 10.75 9.625V16.375C10.75 16.9963 10.2463 17.5 9.625 17.5C9.00368 17.5 8.5 16.9963 8.5 16.375V9.625C8.5 9.00368 9.00368 8.5 9.625 8.5ZM15.25 11.125C15.25 10.5037 15.7537 10 16.375 10C16.9963 10 17.5 10.5037 17.5 11.125V14.875C17.5 15.4963 16.9963 16 16.375 16C15.7537 16 15.25 15.4963 15.25 14.875V11.125ZM5.875 10.75C6.49632 10.75 7 11.2537 7 11.875V14.125C7 14.7463 6.49632 15.25 5.875 15.25C5.25368 15.25 4.75 14.7463 4.75 14.125V11.875C4.75 11.2537 5.25368 10.75 5.875 10.75ZM19 12.625C19 12.0037 19.5037 11.5 20.125 11.5C20.7463 11.5 21.25 12.0037 21.25 12.625V13.375C21.25 13.9963 20.7463 14.5 20.125 14.5C19.5037 14.5 19 13.9963 19 13.375V12.625ZM6.25 17.5C6.66421 17.5 7 17.8358 7 18.25V19H7.75C8.16421 19 8.5 19.3358 8.5 19.75C8.5 20.1642 8.16421 20.5 7.75 20.5H7V21.25C7 21.6642 6.66421 22 6.25 22C5.83579 22 5.5 21.6642 5.5 21.25V20.5H4.75C4.33579 20.5 4 20.1642 4 19.75C4 19.3358 4.33579 19 4.75 19H5.5V18.25C5.5 17.8358 5.83579 17.5 6.25 17.5Z"
                        fill="#1F2225" 
                        />
                    </g>
                    <defs>
                      <clipPath id="clip0_10957_241283">
                        <rect width="26" height="26" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
            </div>
            <!-- 麦克风图标 -->
            <div class="icon-container" ref="mic-box" @mouseenter="() => { hidenPover('mic'); handleHideVoiceCloseTip() }">
              <div class="icon" @click="handleOperate('mic')">
                <i 
                  v-if="limitations?.tooltip" 
                  v-tooltip="{ text: limitations?.tooltip }" 
                  class="iconfont icon-mic-locked"
                ></i>
                <i 
                  v-else-if="is_mic_mute" 
                  v-tooltip="{ text: '已被静音' }" 
                  class="iconfont icon-mic-off"
                ></i>
                <i
                  v-else-if="is_no_mic"
                  v-tooltip="{text: noMicTooltip}"
                  class="iconfont icon-mic-missing"
                  style="color: #F64E54"
                ></i>
                <template v-else>
                  <svg 
                    class="mute-svg" 
                    v-show="setting_data.micLevel == 0 || !is_login"
                    t="1675167391873"
                    viewBox="0 0 1024 1024" 
                    version="1.1" 
                    xmlns="http://www.w3.org/2000/svg" 
                    p-id="2255" 
                    width="200"
                    height="200"
                    key="mic"
                    >
                    <path
                      d="M315.52 148.992l423.253333 359.722667c5.12-19.370667 7.893333-39.68 7.893334-60.714667v-170.666667A234.666667 234.666667 0 0 0 315.52 148.992zM797.141333 558.378667l69.333334 58.88A382.848 382.848 0 0 0 896 469.333333v-42.666666a42.666667 42.666667 0 1 0-85.333333 0v42.666666c0 31.018667-4.693333 60.928-13.525334 89.045334zM287.744 517.376a234.922667 234.922667 0 0 0 191.872 163.072l-191.872-163.072z"
                      fill="var(--text-2)" 
                      p-id="2256"
                      ></path>
                    <path
                      d="M142.933333 394.24A42.581333 42.581333 0 0 0 128 426.666667v42.666666c0 197.674667 149.333333 360.448 341.333333 381.653334V917.333333H298.666667a42.666667 42.666667 0 1 0 0 85.333334h426.666666a42.666667 42.666667 0 1 0 0-85.333334h-170.666666v-66.346666a381.738667 381.738667 0 0 0 97.365333-23.978667l-77.226667-65.621333A298.666667 298.666667 0 0 1 213.333333 469.333333v-15.232L142.933333 394.24z"
                      fill="var(--text-2)" 
                      p-id="2257"
                      ></path>
                    <path
                      d="M36.565333 107.904a64 64 0 0 1 90.197334-7.338667l853.333333 725.333334a64 64 0 1 1-82.858667 97.536l-853.333333-725.333334a64 64 0 0 1-7.338667-90.197333z"
                      class="error-line" 
                      p-id="2258" 
                      fill="var(--f-error-text)"
                      ></path>
                  </svg>
                  <div class="mic-icon" v-show="setting_data.micLevel != 0 && is_login">
                    <div class="gray"></div>
                    <div class="green"
                      :style="{ height: micIconHeight + 'px' }"
                    >
                    </div>
                    <svg 
                      width="26" 
                      height="26" 
                      viewBox="0 0 26 26" 
                      fill="none" 
                      xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_33953_416371)">
                        <path 
                          :style="{ fill: emphasize_show_theme_bg_color }"
                          d="M26 0H0V26H26V0ZM8.875 8.875C8.875 6.59683 10.7218 4.75 13 4.75C15.2782 4.75 17.125 6.59683 17.125 8.875V11.875C17.125 14.1532 15.2782 16 13 16C10.7218 16 8.875 14.1532 8.875 11.875V8.875ZM7 10.75C7.41421 10.75 7.75 11.0858 7.75 11.5V12.25C7.75 15.1495 10.1005 17.5 13 17.5C15.8995 17.5 18.25 15.1495 18.25 12.25V11.5C18.25 11.0858 18.5858 10.75 19 10.75C19.4142 10.75 19.75 11.0858 19.75 11.5V12.25C19.75 15.7244 17.125 18.5857 13.75 18.9588V20.125H16.75C17.1642 20.125 17.5 20.4608 17.5 20.875C17.5 21.2892 17.1642 21.625 16.75 21.625H9.25C8.83579 21.625 8.5 21.2892 8.5 20.875C8.5 20.4608 8.83579 20.125 9.25 20.125H12.25V18.9588C8.87504 18.5857 6.25 15.7244 6.25 12.25V11.5C6.25 11.0858 6.58579 10.75 7 10.75Z"
                          fill="#1F2225" />
                      </g>
                      <defs>
                        <clipPath id="clip0_33953_416371">
                          <rect width="26" height="26" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </template>
                <PressBtn 
                  :key="JSON.stringify(setting_data.audio_press_key)"
                  :value="setting_data.audio_press_key && getKeyName(setting_data.audio_press_key) || '未设置'" 
                  :isPress="is_press"
                  :bgColor="emphasize_show_theme_bg_color"
                  v-if="is_login && setting_data.audio_press_mode">
                </PressBtn>
              </div>
            </div>
            <!-- 扬声器图标 -->
            <div class="icon-container" ref="voice-box" @mouseenter="hidenPover">
              <div class="icon" @click="handleOperate('voice')">
                <i v-if="is_earphone_mute" v-tooltip="{ text: '已被耳机静音' }" class="iconfont icon-speak-off"></i>
                <template v-else>
                  <svg 
                    class="mute-svg" 
                    v-show="setting_data.voiceLevel == 0||!is_login" 
                    t="1675167501502"
                    viewBox="0 0 1024 1024" 
                    version="1.1" 
                    xmlns="http://www.w3.org/2000/svg" 
                    p-id="2407" 
                    width="200"
                    height="200"
                    >
                    <path
                      d="M89.088 348.501333A72.96 72.96 0 0 0 85.333333 371.669333v280.661334c0 40.32 32.682667 72.96 72.96 72.96 91.306667 0 180.309333 28.586667 254.592 81.621333l84.181334 60.16c28.16 20.096 42.24 30.165333 53.845333 31.146667a42.666667 42.666667 0 0 0 40.533333-20.821334c5.888-10.026667 5.888-27.306667 5.888-61.952v-34.901333L89.088 348.501333zM597.333333 388.522667V208.554667c0-34.645333 0-51.968-5.888-61.994667a42.666667 42.666667 0 0 0-40.533333-20.821333c-11.562667 1.024-25.685333 11.093333-53.845333 31.189333l-84.181334 60.16c-3.157333 2.261333-6.314667 4.437333-9.514666 6.613333L597.333333 388.522667zM802.858667 563.2A170.752 170.752 0 0 0 682.666667 346.709333v91.434667c21.12 12.202667 36.522667 33.194667 41.173333 57.984l79.018667 67.157333z"
                      fill="var(--text-2)" 
                      p-id="2408"
                      ></path>
                    <path
                      d="M980.650667 512c0 60.16-15.616 116.736-43.008 165.802667l-65.621334-55.808A256.768 256.768 0 0 0 682.666667 258.816V173.994667A340.693333 340.693333 0 0 1 980.650667 512z"
                      fill="var(--text-2)" 
                      p-id="2409"
                      ></path>
                    <path
                      d="M36.565333 107.904a64 64 0 0 1 90.197334-7.338667l853.333333 725.333334a64 64 0 1 1-82.858667 97.536l-853.333333-725.333334a64 64 0 0 1-7.338667-90.197333z"
                      fill="var(--f-error-text)" 
                      p-id="2410" 
                      class="error-line"
                      ></path>
                  </svg>
                  <i class="iconfont icon-speak-on" v-show="setting_data.voiceLevel != 0 && is_login"></i>
                </template>
              </div>

            </div>
            <div class="close-mic-state-tip white-tip" v-if="showVoiceCloseTip" @mouseenter="handleHideVoiceCloseTip">
              你目前处于静音状态！
            </div>
          </div>
        </div>
      </template>
      </div>
      <div 
        v-show="!showFullPanel"
        class="mini-voice-panel-container pointer flex justify-center items-center rounded-[8px] bg-fl-ip transition-[border-radius] duration-200"       
        :style="{
          background: emphasize_show_theme_bg_color,
        }">
          <div 
            class="avatar-container"
            v-if="!cur_channel_data.channel_id"  
          >
            <Avatar 
              class="avatar" 
              :img="user_info.avatar || infoPreLoad('avatar') || CHAT_LOGO_IMG" 
              :onlineState="isCheckingLogin ? 1 : online_state "
              :avatar_decoration="user_info.avatar_decoration || {}" 
            />
          </div>
          <div 
            class="channel-audio-state"
            :class="{
              'audio-loading' : channel_connecting
            }"
            v-else
          >
            <i class="iconfont icon-dial" />
            <div class="audio-remain-state">
              {{
                channel_connecting ?
                  audioStateText :
                  ' ' + (remainHour ? remainHour + ':' : '') + remainMin + ':' + remainSec
              }}
            </div>
          </div>
      </div>

    <LaughterTrackSelector 
      v-if="showLaughterSelector" 
      :calPos="laughterCalPos"
      @changeShowValue="v => showLaughterSelector = v"  
      ref="laughter-selector"
    />
    <BgmSelector 
      v-if="isClient && show_bgm_selector" 
      @changeShowValue="v => SET_SHOW_BGM_SELECTOR(v)" 
      @changeTrtcSystemAudio="trtcSystemAudioChange" 
      @reportBgmState="reportBgmState" 
      @changeBgmId="changeBgmState"
    />

    <PopingIcon v-if="showUserCardGuide" :left="81" class="user-card-guide"
      @click.native="userCardMenu($event, 'mine', user_info)" :no_guide="true" />
    <Guide v-if="showAudioGuide" guide_type="enter_audio_channel" @show="showGuideIcon = false">
      <div class="guide-enter-audio-channel-btn" @click.stop="">
        <PopingIcon :left="16" :top="-16" :no_guide="true" :hidden="!showGuideIcon" />
        <div class="trigger-click-area"></div>
      </div>
    </Guide>
    <Guide v-if="showMinimalGuide" guide_type="use_minimal" @show="showMinimalGuideIcon = false">
      <div class="guide-enter-audio-channel-btn use-minimal-guide" @click.stop="">
        <PopingIcon :left="16" :top="-16" :no_guide="true" :hidden="!showMinimalGuideIcon" />
        <div class="trigger-click-area"></div>
      </div>
    </Guide>
    <!-- 麦克风弹窗 -->
    <Popover 
      key="mic-popover" 
      ref="mic-popover" 
      :triggerType="'hover'" 
      :triggerRef="micPopoverTrigger"
      :appendToBody="false"
      class="operation-setting" 
      :hideDelay="300" 
      :disable="!is_login || is_mic_mute || is_no_mic"
      @updateShow="checkDeviceAutoEllipsis"
      @mouseenter.native="handleHoverPopover(true)"
      @mouseleave.native="handleHoverPopover(false)"
      autoPos="left bottom"
      :offset="{
        y: -34,
        x: -72,
      }"
      >
      <div class="block">
        <p class="title">输入设备</p>
        <Radio 
          v-for="(item, index) in setting_data.micDevices" 
          :key="index" 
          :label="item.label"
          :active="item.deviceId == setting_data.curMicId" :isTooptip="true"
          @click="changeDevice('mic', item.deviceId)"
        ></Radio>
        <Radio 
          v-if="isAllowPhoneMic" 
          :label="phoneMicLabel" 
          :active="PHONE_MIC_ID === setting_data.curMicId"
          :icon="is_phone_mic_connecting ? '' : 'icon-add-circle'"
          @click="is_phone_mic_connecting ? changeDevice('mic', PHONE_MIC_ID) : EventBus.$emit('set_dialog_visible:PhoneMicConnect')"
          >
        </Radio>
      </div>
      <div class="block">
        <div class="row switch-row" @click="handleSwitchAudioPressMode">
          <div class="text-block">
            <p class="text">按键说话 <span class="desc" v-if="pressBtnText">({{ pressBtnText }})</span></p>
            <!-- <p class="desc" v-if="setting_data.audio_press_key">{{ getKeyName(setting_data.audio_press_key, 'string', ' + ') }}</p> -->
          </div>
          <el-switch :value="setting_data.audio_press_mode" class="switch"></el-switch>
        </div>
        <div class="row" @click="EventBus.$dynamic('UserConfig', 'audio')">
          更多声音设置
        </div>
      </div>
      <div class="block">
        <div class="slider-row" @click.prevent>
          <div class="row-1">
            <span>输入音量</span>
            <svg 
              @click="handleOperate('mic')" 
              v-show="setting_data.micLevel == 0" 
              t="1675167391873"
              viewBox="0 0 1024 1024" 
              version="1.1" 
              xmlns="http://www.w3.org/2000/svg" 
              p-id="2255" 
              width="200"
              height="200"
              >
              <path
                d="M315.52 148.992l423.253333 359.722667c5.12-19.370667 7.893333-39.68 7.893334-60.714667v-170.666667A234.666667 234.666667 0 0 0 315.52 148.992zM797.141333 558.378667l69.333334 58.88A382.848 382.848 0 0 0 896 469.333333v-42.666666a42.666667 42.666667 0 1 0-85.333333 0v42.666666c0 31.018667-4.693333 60.928-13.525334 89.045334zM287.744 517.376a234.922667 234.922667 0 0 0 191.872 163.072l-191.872-163.072z"
                fill="var(--text-2)" 
                p-id="2256"
                ></path>
              <path
                d="M142.933333 394.24A42.581333 42.581333 0 0 0 128 426.666667v42.666666c0 197.674667 149.333333 360.448 341.333333 381.653334V917.333333H298.666667a42.666667 42.666667 0 1 0 0 85.333334h426.666666a42.666667 42.666667 0 1 0 0-85.333334h-170.666666v-66.346666a381.738667 381.738667 0 0 0 97.365333-23.978667l-77.226667-65.621333A298.666667 298.666667 0 0 1 213.333333 469.333333v-15.232L142.933333 394.24z"
                fill="var(--text-2)" 
                p-id="2257"
                ></path>
              <path
                d="M36.565333 107.904a64 64 0 0 1 90.197334-7.338667l853.333333 725.333334a64 64 0 1 1-82.858667 97.536l-853.333333-725.333334a64 64 0 0 1-7.338667-90.197333z"
                fill="var(--f-error-text)" 
                p-id="2258"
                ></path>
            </svg>
            <i v-show="setting_data.micLevel != 0"  @click="handleOperate('mic')" class="iconfont icon-mic-on"></i>
          </div>
          <Slider 
            :min="0" 
            :max="150" 
            :value="setting_data.micLevel" 
            @click.native.capture="handleCheckSpeakFreely"
            @change="changeMicLevel" 
            class="slider"
            :tooltip-formatter="(val) => causeNoiseTipFormatter(val, 100)"
          />
        </div>
      </div>
    </Popover>
    <!-- 扬声器弹窗 -->
    <Popover 
      key="voice-popover" 
      ref="voice-popover" 
      :triggerType="'hover'" 
      :triggerRef="voicePopoverTrigger"
      :appendToBody="false"
      class="operation-setting" 
      :hideDelay="300" 
      :disable="!is_login || cur_channel_data.mute_earphone"
      @updateShow="checkDeviceAutoEllipsis"
      @mouseenter.native="handleHoverPopover(true)"
      @mouseleave.native="handleHoverPopover(false)"
      autoPos="left bottom"
      :offset="{
        y: -34,
        x: -72,
      }"
      >
      <div class="block">
        <p class="title">输出设备</p>
        <Radio 
          v-for="(item, index) in setting_data.voiceDevices" 
          :key="index" 
          :label="item.label"
          :active="item.deviceId == setting_data.curVoiceId" 
          :isTooptip="true"
          @click="changeDevice('voice', item.deviceId)"></Radio>
      </div>
      <div class="block">
        <div class="slider-row" @click.prevent>
          <div class="row-1">
            <span>输出音量</span>
            <svg 
              @click="handleOperate('voice')" 
              v-show="setting_data.voiceLevel == 0 || !is_login" 
              t="1675167501502"
              viewBox="0 0 1024 1024" version="1.1" 
              xmlns="http://www.w3.org/2000/svg" 
              p-id="2407" width="200"
              height="200"
              >
              <path
                d="M89.088 348.501333A72.96 72.96 0 0 0 85.333333 371.669333v280.661334c0 40.32 32.682667 72.96 72.96 72.96 91.306667 0 180.309333 28.586667 254.592 81.621333l84.181334 60.16c28.16 20.096 42.24 30.165333 53.845333 31.146667a42.666667 42.666667 0 0 0 40.533333-20.821334c5.888-10.026667 5.888-27.306667 5.888-61.952v-34.901333L89.088 348.501333zM597.333333 388.522667V208.554667c0-34.645333 0-51.968-5.888-61.994667a42.666667 42.666667 0 0 0-40.533333-20.821333c-11.562667 1.024-25.685333 11.093333-53.845333 31.189333l-84.181334 60.16c-3.157333 2.261333-6.314667 4.437333-9.514666 6.613333L597.333333 388.522667zM802.858667 563.2A170.752 170.752 0 0 0 682.666667 346.709333v91.434667c21.12 12.202667 36.522667 33.194667 41.173333 57.984l79.018667 67.157333z"
                fill="var(--text-2)" 
                p-id="2408"
                ></path>
              <path
                d="M980.650667 512c0 60.16-15.616 116.736-43.008 165.802667l-65.621334-55.808A256.768 256.768 0 0 0 682.666667 258.816V173.994667A340.693333 340.693333 0 0 1 980.650667 512z"
                fill="var(--text-2)" 
                p-id="2409"
                ></path>
              <path
                d="M36.565333 107.904a64 64 0 0 1 90.197334-7.338667l853.333333 725.333334a64 64 0 1 1-82.858667 97.536l-853.333333-725.333334a64 64 0 0 1-7.338667-90.197333z"
                fill="var(--f-error-text)" 
                p-id="2410"
                ></path>
            </svg>
            <i v-show="setting_data.voiceLevel != 0 && is_login"  @click="handleOperate('voice')" class="iconfont icon-speak-on"
              :class="[setting_data.voiceLevel == 0 ? 'icon-speak-off-color' : 'icon-speak-on']"></i>
          </div>
          <Slider :value="setting_data.voiceLevel" @change="changeVoiceLevel" class="slider"></Slider>
        </div>
      </div>
    </Popover>
    <Popover 
      key="ai-denoiser-popover" 
      ref="ai-denoiser-popover" 
      :triggerType="'hover'" 
      :triggerRef="aiDenoiserPopoverTrigger"
      :appendToBody="false"
      class="operation-setting ai-denoiser-setting" 
      :hideDelay="300" 
      @mouseenter.native="handleHoverPopover(true)"
      @mouseleave.native="handleHoverPopover(false)"
      autoPos="left bottom"
      :offset="{
        y: -34,
        x: -72,
      }"
      >
      <div class="block">
        <div class="row switch-row ai-row" v-remind-to-login="{ cb: handleChangeAIDenoiser}" >
          <div class="switch-ai">
            <i class="iconfont icon-vpr left-icon"></i>
            <p class="text">AI降噪</p>
            <el-switch :value="setting_data.AI_denoiser_V2" class="switch"></el-switch>
          </div>
          <p class="weak-text">麦克风AI降噪可以消除你的背景音，只保留人声</p>
        </div>
        <div 
          class="row switch-row" 
          style="position: relative;"
          @mouseenter="handleAIDenoiserVersionMenu(true)"
          @mouseleave="handleAIDenoiserVersionMenu(false)"
          v-if="isClient && user_account_settings.audio_clear_mode == 1 && cur_channel_data.api_type !== 'volc'"
        >
          <p class="text">降噪版本</p>
          <i class="iconfont icon-arrow-left"></i>
          <div 
            class="ai-denoiser-version-menu"
            v-if="showAIDenoiserVersionMenu"
          >
            <div class="menu-container heybox-context-menu-wrapper">
              <Radio 
                v-for="item in TRTC_AI_DENOISER_VERSION_OPTIONS"
                :label="item.label" 
                :active="user_account_settings.trtc_ai_denoise_version === item.value"
                :key="item.value"
                :reverse="true" 
                :class="{'highlight': aiDenoiserHoverVal === item.value && showAIDenoiserTypeMenu}"
                @click="changeAIDenoiserVersion(item.value)"
                @mouseenter.native="handleMouseEnterDenoiser(item, true)"
                @mouseleave.native="handleMouseEnterDenoiser(item, false)"
                :is_sub_menu="!!item.options"
              >
              </Radio>
            </div>
          </div>
          <div 
            class="ai-denoiser-type-menu"
            v-if="showAIDenoiserTypeMenu"
            @mouseenter="handleMouseTypeMenu(true)"
            @mouseleave="handleMouseTypeMenu(false)"
          >
            <div class="menu-container heybox-context-menu-wrapper">
              <Radio 
                v-for="item in TRTC_AI_DENOISER_TYPE_OPTIONS"
                :label="item.label" 
                :active="user_account_settings.trtc_ai_denoise_type === item.value"
                @click="changeAIDenoiserType(item.value)"
                :key="item.value"
                :reverse="true" 
              >
              </Radio>
            </div>
          </div>
        </div>
      </div>
      <div class="block">
        <div 
          class="row switch-row"
          v-remind-to-login="{ cb: () => handleChangeAdvanceConfig({'AEC': !setting_data.AEC})}"
        >
          <p class="text">回声消除</p>
          <el-switch :value="setting_data.AEC" class="switch"></el-switch>
        </div>
        <div 
          class="row switch-row" 
          v-remind-to-login="{ cb: () => handleChangeAdvanceConfig({'AGC': !setting_data.AGC})}"
        >
          <p class="text">麦克风智能调节</p>
          <el-switch :value="setting_data.AGC" class="switch"></el-switch>
        </div>
        <div 
          class="row switch-row" 
          v-remind-to-login="{ cb: () => handleChangeAdvanceConfig({'ANS': !setting_data.ANS})}"
        >
          <p class="text">噪声抑制</p>
          <el-switch :value="setting_data.ANS" class="switch"></el-switch>
        </div>
        <div 
          class="row switch-row" 
          v-remind-to-login="{ cb: () => $rtc.handleChangeClearMode(user_account_settings.audio_clear_mode ? 0 : 1)}"
          v-if="isClient"
        >
          <div class="text-block">
            <p class="text">清晰模式</p>
          </div>
          <el-switch :value="!!user_account_settings.audio_clear_mode" class="switch"></el-switch>
        </div>
        <div class="row" v-remind-to-login="{ cb: () => EventBus.$dynamic('UserConfig', 'audio')}">
          更多声音设置
        </div>
      </div>

      <div class="block">
        <div 
          class="row switch-row" 
          v-remind-to-login="{ cb: () => SET_SETTING_DATA_PARAM({'show_overlay': !setting_data.show_overlay})}"
          v-if="isClient"
        >
          <p class="text">开启游戏内覆盖</p>
          <el-switch :value="setting_data.show_overlay" class="switch"></el-switch>
        </div>
        <div 
          class="row switch-row" 
          v-remind-to-login="{ cb: () => SET_SETTING_DATA_PARAM({'limit_working_set': !setting_data.limit_working_set})}"
          v-if="isClient"
        >
          <p class="text">内存优化(Beta)</p>
          <el-switch :value="setting_data.limit_working_set" class="switch"></el-switch>
        </div>
        <div class="row" v-remind-to-login="{ cb: () => EventBus.$dynamic('UserConfig', 'overlay')}">
          更多设置
        </div>
      </div>
    </Popover>
    <Popover 
      key="record-popover" 
      ref="record-popover" 
      :triggerType="'hover'" 
      :triggerRef="recordPopoverTrigger"
      class="record-popover-wrapper w-[188px] rounded-[8px] bg-fl-pp flex flex-col items-start border border-op-1 shadow-[0px_3px_15px_0px_rgba(0,0,0,0.35)] p-[8px] border-solid" 
      :hideDelay="300" 
      :disable="is_recording || showRecordOperationTip || !isClient"
      autoPos="left bottom"
      :offset="{
        y: -34,
        x: -72,
      }"
      >
      <div class="record-popover-panel w-full">
        <div class="title flex items-center gap-[2px] self-stretch px-[8px] py-[6px] overflow-hidden text-tx-3 text-ellipsis text-[12px] font-bold leading-[16px] tracking-[0.12px]">录制语音(Beta)</div>
        <div 
          class="row flex-[1_0_0] flex items-center gap-[8px] self-stretch px-[8px] py-[6px] rounded-[5px] hover:bg-bd-fl cursor-pointer"
          @click="handleClickSwitchPreRecord"
        >
          <div class="left flex-[1_0_0] overflow-hidden text-tx-2 text-ellipsis text-[14px] leading-[18px] tracking-[0.14px]">预录语音 100s</div>
          <div class="checkbox">
            <i
              class="icon-toast-success-square iconfont"
              v-if="!!setting_data.pre_record_switch"
            ></i>
          </div>
        </div>
        <div 
          class="row flex-[1_0_0] flex items-center gap-[8px] self-stretch px-[8px] py-[6px] overflow-hidden text-tx-2 text-ellipsis text-[14px] leading-[18px] tracking-[0.14px] cursor-pointer rounded-[5px] hover:bg-bd-fl"
          @click="handleOpenRecordFile"
        >
          录音文件
        </div>
        <div class="record-tip-desc flex items-center gap-[2px] self-stretch px-[8px] py-[6px] overflow-hidden text-tx-4 text-ellipsis text-[12px] leading-[16px] tracking-[0.12px]">*单次最长可录制1小时</div>
      </div>
    </Popover>
  </div>
</template>

<script>
import Avatar from '_com/func/Avatar'
import Radio from '_com/menu/Radio'
import Popover from '_com/func/Popover'

const KbpsSpan = () => import('_com/busy/KbpsSpan.vue')
const AvLineIcon = () => import('_com/busy/AvLineIcon.vue')
const PressBtn = () => import('../PressBtn.vue')
const AdvertisementPanel = () => import('./components/AdvertisementPanel')
const VerifiedNotice = () => import('./components/VerifiedNotice')

const PopingIcon = () => import('@/views/room/components/PopingIcon.vue')
const Guide = () => import('@/layout/components/guide/index.vue')
const BgmSelector = () => import('./components/BgmSelector') 
const LaughterTrackSelector = () => import('../Laughter/LaughterTrackSelector')
const GameDisplayBlock = () => import('./components/GameDisplayBlock.vue')
import { mapGetters, mapMutations, mapActions } from 'vuex'

import EventBus from '@/common/EventBus'
import {
  debounce,
  checkLoginStatusAsync,
  getRandom,
  copyText,
  getStorage,
  setStorage,
  getCookie,
  findChildComponents,
  electronVersionAfter30,
} from '_lib/utils/utils'
import { getIndexFromArrayByKeyValue } from '_lib/utils/utilsArray'
import { reportUserVoiceState } from '_api/channel'
import { enterChannel } from "_api/ws.js";
import { reportData } from '_api/report'
import { completeOnceTaskV2 } from "_api/task.js";
import { addFriend, checkIsFriends } from '_api/friend';
import { checkScreenShare } from '_api/screen-share';
import { updateAccountSetting, getMinimalVersion } from '_api/settings'
import { getUserLaughterTracks, sendSoundMessage } from '_api/voice'

import BgmSelectorMixin from './mixins/BgmSelectorMixin'

import kmMixin from '_mixin/kmEvent.js'

import audioSettingMixin from '_mixin/audioSetting'
import soundMessagePlayer from "_mixin/soundMessagePlayer.js"
import { findChannel, findChannelSync } from '_js/find-channel'
import { ONCE_TASK_TYPES, SPEAK_FREELY_QUERY_CONFIG_TYPE_MAP } from '@/common/constants/tasks'
import { 
  PHONE_MIC_ID, 
  RTC_ABILITY, 
  RTC_CONTTECTION_STATE,
  TRTC_AI_DENOISER_VERSION_OPTIONS,
  TRTC_AI_DENOISER_TYPE_OPTIONS,
  TRTC_AI_DENOISER_VERSION_VALUE_MAP,
} from '@/common/constants/rtc'
import { ROOM_ICON_ID_MAP } from "_lib/constants/room";
import { CHANNEL_USER_UPDATE_MOVE_TYPE } from '_lib/constants/channel'
import { CHAT_LOGO_IMG } from '_lib/constants/global'
import LaughterRouletteMixin from './mixins/LaughterRoulette.js'
import logoutMixin from "_mixin/logout";
import { ADD_VOICE_PANEL_ALL } from '_lib/constants/friend'
import { WS_RECONNECT_ENTER_ROOM_TIMEOUT } from '_lib/constants/socket'
import { playAudio } from '_lib/utils/utilsMedia'
import shortcut from '_lib/shortcutDeliver'
import { muteCurChannelUserVoice, causeNoiseTipFormatter } from "@/views/room/utils";
import { LAUGHTER_SPECIAL_GROUP_TYPE, LAUGHTER_SPECIAL_ITEM_TYPE } from '_lib/constants/laughter'
import { getGameDisplayInfo } from '_api/game-display'
import { getRtcVolumeIconHeight } from '_lib/dom.js'

export default {
  mixins: [
    kmMixin,
    soundMessagePlayer,
    LaughterRouletteMixin,
    logoutMixin,
    audioSettingMixin,
    BgmSelectorMixin,
  ],
  components: {
    Avatar,
    Radio,
    Popover,
    PressBtn,
    KbpsSpan,
    AvLineIcon,
    BgmSelector,
    LaughterTrackSelector,
    AdvertisementPanel,
    PopingIcon,
    Guide,
    VerifiedNotice,
    GameDisplayBlock,
  },
  data() {
    return {
      rightMenuShow: {
        microphone: false,
        voice: false,
      },
      clearRightMenuFunc: null,

      aiDenoiserPopoverTrigger: null,
      micPopoverTrigger: null,
      voicePopoverTrigger: null,
      recordPopoverTrigger: null,
      // userPopoverTrigger: null,

      time_remaining: 0,
      remainHour: '',
      remainMin: '00',
      remainSec: '00',

      networkQuality: 1,
      statisticsQuality: {},
      addFriendLock: false,

      showVoiceCloseTip: false,
      //被管理禁言后操作弹窗
      showMutedByAdminDialog: false,

      changeElectronConfig: {
        title: '开启共享伴奏',
        desc: '开启后将刷新页面，自动切换为伴奏模式，如果通话质量受到影响，可以前往设置-通用设置关闭。',
        confirm: {
          text: '开启',
        },
        cancel: {
          text: '取消'
        }
      },

      showLaughterSelector: false,

      DEFAULT_BGM_IMAGE: 'https://imgheybox.max-c.com/oa/2023/08/31/6e16ffbe8bffea3ebcae859f02bdc780.png',
      operate_type: '',


      PHONE_MIC_ID,
      EventBus,

      showGuideIcon: true,
      showMinimalGuideIcon: true,

      isCheckingLogin: true,
      CHAT_LOGO_IMG:CHAT_LOGO_IMG,

      showAIDenoiserVersionMenu: false, // 是否展示ai降噪icon悬浮窗中的ai降噪版本菜单
      showAIDenoiserTypeMenu: false, // 是否展示ai降噪icon悬浮窗中的ai降噪类型菜单
      reEnterChannelTimes: 0, // ws重连后调用reEnterChannelT的重试次数

      speakFreelyLock: false,
      tempMicLevel: 0,

      showBgmLowVerisonTip: false,
      showScreenLowVerisonTip: false,

      TRTC_AI_DENOISER_VERSION_OPTIONS,
      TRTC_AI_DENOISER_TYPE_OPTIONS,
      aiDenoiserHoverVal: -1,

      needExpend: false,
      inHomeExpendAnimation: '',
      readAdvertisement: false,
      readGameDisplay: false,
      afterExpended: false,
      mouseInWrapper: false,
      gameDisplayInfo: {},
      isShowGetcreenShare: false,
      getScreenShareData: null,
      lastRecordId: '',
      recordingTime: 0,
      showRecordOperationTip: false,
      recordOperationConfig: {
        title: '',
        desc: '',
        icon: '',
        iconColor: '',
        confirm: '',
        confirmCB: () => {},
      },
      isHoveringPopover: false,
      cptWidth: 0,

      laughterCalPos: null,

      channelStrangers: [],
    }
  },
  created() {
    this.clearRightMenuFunc = () => {
      this.rightMenuShow = {
        microphone: false,
        voice: false,
      }
    }
    this.isChecking()
  },
  mounted() {
    this.aiDenoiserPopoverTrigger = this.$refs['ai-denoiser-box']
    this.micPopoverTrigger = this.$refs['mic-box']
    this.voicePopoverTrigger = this.$refs['voice-box']
    // this.userPopoverTrigger = this.$refs['user-box']

    EventBus.$on('Report_User_Voice_State', this.reportUserVoiceState)
    EventBus.$on('Socket_Connect', this.reEnterChannel)
    // 处理房间或频道被删除
    EventBus.$on('SOCKET_ROOM_OR_CHANNEL_DELETE', this.handleRoomChannelDelete)
    EventBus.$on('SOCKET_ROOM_INFO_CHANGE', this.handleUserVoice)
    EventBus.$on('rtc-cb:networkCallback', this.handleNetworkQuality)
    EventBus.$on('rtc-cb:statisticsCallback', this.handleStatistics)
    EventBus.$on('User_Speak_Without_Voice', this.handleShowVoiceCloseTip)
    EventBus.$on('SOCKET_REFUSE_AUDIO', this.handleRefuseAudio)
    // 被静音
    EventBus.$on("SOCKET_USER_STATE_UPDATE", this.handleUserStateUpdate);
    EventBus.$on("SOCKET_UPDATE_ROOM_INFO", this.handleRoomUpdateInfo);
    EventBus.$on("SOCKET_SINGLE_CHANNEL_UPDATE", this.handleSingleChannelUpdate);
    EventBus.$on('SOCKET_CHANNEL_USER_UPDATE', this.handleChannelUserUpdate);
    EventBus.$on("set_dialog_visible:mutedByAdmin", this.handleShowMutedByAdminDialog);
    EventBus.$on('SHOW_LAUHGTER_SELECTOR', this.changeShowLaughterSelector);
    EventBus.$on('Bgm_Use_Hook_Warn', this.showBgmHookWarn)
    EventBus.$on('speakFreelyNotice', this.noticeWhenChangeValue)
    EventBus.$on('SOCKET_GET_SCREEN_SHARE', this.showScreenShare)

    // BGM相关
    EventBus.$on('Clear_System_Bgm_state', this.clearBgmState)

    // 语音包组件相关
    shortcut.addShortcut({ key_config: 'laughter_key_map' }, this.handleSendLaughterShortcut)
    EventBus.$on('Refresh_User_Laughter', this.handleRefreshUserLaughter)

    // 房间活动相关
    EventBus.$on('SOCKET_CONFIRM_END_ROOM_ACT', this.handleNoticeEndRoomAct)
    EventBus.$on('Record:StopRecord', this.changeRecordStatus)

    // 录音相关
    EventBus.$on('Record_State_Change', this.handleRecordStateChange)
    EventBus.$on('Show_Record_Operation_Tip', this.handleChangeShowRecordOperationTip)

    EventBus.$on('resizeChannelSideBar', this.handleResizeChannelSideBar)

    // 新版语音频道面板
    EventBus.$on('Audio_Channel_Panel_Action', this.handleAudioChannelPanelAction)

    EventBus.$on('VoicePanel:handleHangUp', this.handleHangUp)
    this.registerShortcuts()
  },
  beforeDestroy() {
    EventBus.$off('Report_User_Voice_State', this.reportUserVoiceState)
    EventBus.$off('Socket_Connect', this.reEnterChannel)
    EventBus.$off('SOCKET_ROOM_OR_CHANNEL_DELETE', this.handleRoomChannelDelete)
    EventBus.$off('SOCKET_ROOM_INFO_CHANGE', this.handleUserVoice)
    EventBus.$off('rtc-cb:networkCallback', this.handleNetworkQuality)
    EventBus.$off('rtc-cb:statisticsCallback', this.handleStatistics)
    EventBus.$off('User_Speak_Without_Voice', this.handleShowVoiceCloseTip)
    EventBus.$off('SOCKET_REFUSE_AUDIO', this.handleRefuseAudio)
    EventBus.$off("SOCKET_USER_STATE_UPDATE", this.handleUserStateUpdate);
    EventBus.$off("SOCKET_UPDATE_ROOM_INFO", this.handleRoomUpdateInfo);
    EventBus.$off("SOCKET_SINGLE_CHANNEL_UPDATE", this.handleSingleChannelUpdate);
    EventBus.$off('SOCKET_CHANNEL_USER_UPDATE', this.handleChannelUserUpdate);
    EventBus.$off("set_dialog_visible:mutedByAdmin", this.handleShowMutedByAdminDialog);
    EventBus.$off('SHOW_LAUHGTER_SELECTOR', this.changeShowLaughterSelector);
    EventBus.$off('Bgm_Use_Hook_Warn', this.showBgmHookWarn)
    EventBus.$off('speakFreelyNotice', this.noticeWhenChangeValue)
    EventBus.$off('SOCKET_GET_SCREEN_SHARE', this.showScreenShare)

    EventBus.$off('Clear_System_Bgm_state', this.clearBgmState)

    shortcut.removeShortcut('laughter_key_map')
    EventBus.$off('Refresh_User_Laughter', this.handleRefreshUserLaughter)
    EventBus.$off('SOCKET_CONFIRM_END_ROOM_ACT', this.handleNoticeEndRoomAct)
    EventBus.$off('Record:StopRecord', this.changeRecordStatus)
    EventBus.$off('Record_State_Change', this.handleRecordStateChange)
    EventBus.$off('Show_Record_Operation_Tip', this.handleChangeShowRecordOperationTip)
    EventBus.$off('resizeChannelSideBar', this.handleResizeChannelSideBar)
    EventBus.$off('Audio_Channel_Panel_Action', this.handleAudioChannelPanelAction)
    EventBus.$off('VoicePanel:handleHangUp', this.handleHangUp)

    
    this.unregisterShortcuts()

    clearTimeout(this._hideAiIenoiserVersionMenuTimer)
    this._hideAiIenoiserVersionMenuTimer = null
    this.clearExpendedTimer()
    document.removeEventListener('click', this.handleClearShowRecordOperationTip)
    if(this._addClearRecordTipTimer) {
      clearTimeout(this._addClearRecordTipTimer)
      this._addClearRecordTipTimer = null
    }
  },
  watch: {
    'setting_data.micLevel': {
      handler: function (v) {
        this.handleMicLevelChange(v)
      },
    },
    'setting_data.voiceLevel': {
      handler: function (v) {
        this.reportUserVoiceState(true)
        this.$rtc.changeOperationVoice(v)
      },
    },
    'setting_data.audio_press_mode': {
      handler: function (v, oldV) {
        if (v !== Boolean(oldV)) {
          this.$rtc.setMuted(v)
        }
      },
      immediate: true,
    },
    rightMenuShow: {
      handler: function (v) {
        let opened = false
        for (let k in v) {
          if (v[k]) {
            opened = true
            document.body.addEventListener('click', this.clearRightMenuFunc)
          }
        }
        if (!opened) {
          document.body.removeEventListener('click', this.clearRightMenuFunc)
        }
      },
      deep: true,
    },
    channel_connecting(v) {
      if (!v && this.cur_channel_data.channel_id) {
        this.startTimeInterval()
      }
    },
    cur_channel_data: {
      handler: function (v, oldV) {
        if (v.channel_id != oldV.channel_id || v.refuse_user_audio != oldV.refuse_user_audio) {
          if (this.calLoop) {
            clearInterval(this.calLoop)
            this.time_remaining = 0
            this.networkQuality = 1
            this.addFriendLock = false
          }
        }
        // BGM组件逻辑
        if (v.channel_id !== oldV.channel_id) {
          this.changeBgmState(false);
          this.channelStrangers = []
        }
        if(v.channel_id) {
          this.$nextTick(() => {
            const recordDom = document.querySelector('.operate-block-record')
            this.recordPopoverTrigger = recordDom
          })
        }
      },
      deep: true,
    },
    hasScreenSharePermission(v) {
      if (!v && this.my_screen_sharing) {
        this.$rtc.stopScreenCapture()
      }
    },
    speakFreelyAbout: {
      handler(v){
        const {cur_channel_data, cur_my_roles, cur_roles_list} = v
        if(!cur_channel_data.channel_id){
          this.noticeSpeakNotFreely(true)
          return
        }
        const result = this.$permission.judge('SpeakFreely', cur_channel_data, false, { my_roles: cur_my_roles, roles: cur_roles_list })
        this.noticeSpeakNotFreely(!!result)
      },
      deep: true,
    },
    showFullPanel(newV){
      if(newV){
        this._setAfterExpended = setTimeout(() => {
          this.afterExpended = true
          clearTimeout(this._setAfterExpended)
        }, 160)
      } else {
        if(this.$refs['mic-popover']) this.hidenPover()
        this.clearExpendedTimer()
        this.afterExpended = false
      }
    },
    afterExpended(newV){
      if (newV) {
        this.$nextTick(()=>{
          this.aiDenoiserPopoverTrigger = this.$refs['ai-denoiser-box']
          this.micPopoverTrigger = this.$refs['mic-box']
          this.voicePopoverTrigger = this.$refs['voice-box']
        })
      }
    },
    showVerfiedNoticeQuery(v) {
      if (v) {
        this.$query({
          config: {
            title: '当前频道有B站直播用户，为保障直播内容安全，与其连麦需进行实名认证',
            confirm: {
              text: '前往认证'
            },
            cancel: {
              text: '取消'
            },
          },
          confirmCB : () => {
            EventBus.$dynamic('VerifiedDialog', false)
          }
        })
      }
    },
    showAdvertisementPanel: {
      handler(newV){
        if(this.isInHomePage){
          if(newV && !this.readAdvertisement){
            this.needExpend = true
          }
        }
      },
    },
    is_show_game_display_block: {
      handler(newV){
        if(this.isInHomePage){
          if(newV && !this.readGameDisplay){
            this.needExpend = true
          }
        }
      },
    },
    showLaughterSelector: {
      handler(newV){
        if(!newV){
          this.handleMouseLeaveWrapper()
        }
      }
    },
    "setting_data.bgm_volume"(v) {
      this.$rtc.changeBgmVolume(v);
    },
    checkIsPlayingOfficialGame: {
      handler(v, oldV) {
        this.initGameDisplayBlock()
      },
      immediate: true,
    },
    gameDisplayBlockMatter: {
      handler() {
        this.updateGameDisplayBlock()
      },
      deep: true,
    },
    showRecordOperationTip: {
      handler(newV) {
        if(newV) {
          this.$refs['record-popover']?.hidden()
          this._addClearRecordTipTimer = setTimeout(() => {
            document.addEventListener('click', this.handleClearShowRecordOperationTip)
            clearTimeout(this._addClearRecordTipTimer)
            this._addClearRecordTipTimer = null
          })
        } else {
          document.removeEventListener('click', this.handleClearShowRecordOperationTip)
          const recordDom = document.querySelector('.operate-block-record')
          this.recordPopoverTrigger = recordDom
        }
      },
    },
    recordStopMatter: {
      handler(newV) {
        // 如果没有权限或者被静音则需要停止录音和预录
        if(newV.some(item => Boolean(item))) {
          this.$rtc.closeVoiceRecord()
          this.$rtc.stopPreAudioRecordInterval(true)
        } else {
          this.$rtc.startPreAudioRecordInterval()
        }
      }
    },
    'channel_sidebar_width': {
      handler(v) {
        this.cptWidth = v
      },
      immediate: true,
    },
  },
  computed: {
    isHostBanned() {
      if (!this.host_mode) {
        return false
      }
      return !this.hosts.some(hostId => hostId == this.user_info.user_id)
    },
    isVoiceLoading() {
      return this.rtc_connection === RTC_CONTTECTION_STATE.reconnecting || this.channel_connecting
    },
    audioStateText() {
      return this.channel_connecting 
        ? '连接中...' 
        : this.rtc_connection === RTC_CONTTECTION_STATE.reconnecting 
          ? '重连中'
          : '语音中'
    },
    mineStateText() {
      if (this.online_state == 0) {
        return '隐身'
      } else {
        const { game = {}, music = {}, steam = {}, web_steam = {} } = this.user_info.pc_state || {}
        if (this.user_info.display_current_playing_game && steam.steam_game_name) {
          let str = '游戏中: ' + steam.steam_game_name
          if (steam.steam_game_state) {
            str += ` <span class="game-state"> ${steam.steam_game_state}</span>`
          }
          return str
        } else if (this.user_info.display_current_playing_game && (game.game_name || web_steam.web_game_name)) {
          return '游戏中: ' + (game.game_name || web_steam.web_game_name)
        } else if (this.user_info.display_current_music && music.music_name) {
          return '听歌中: ' + music.music_name
        } else {
          if (this.online_state == 1) {
            return '在线'
          } else if (this.online_state == 5) {
            return '离开'
          } else {
            return '请勿打扰'
          }
        }
      }
    },
    phoneMicLabel() {
      let str = '<i class="iconfont icon-log-in-heybox" style="width: 16px;height: 16px;font-size: 16px;margin-right: 6px;display: inline-block;vertical-align: middle;"></i><span style="vertical-align: middle;">手机端麦克风</span>'
      if (!this.setting_data.hide_phone_mic_new) {
        str += '<img style="width: 40px;height: 22px;display: inline-block; vertical-align: middle;margin-left: 2px;" src="https://imgheybox.max-c.com/oa/2023/10/27/a7ffa2facec474b0066fee677dd73b6e.png" alt=""/>'
      }
      return str
    },
    showUserCardGuide() {
      return this.show_once_task_by_id(ONCE_TASK_TYPES.user_card_guide)
    },
    maskBackgroundColor() {
      if (this.show_theme_data.show_channel_bar_filter) return ''
      if (this.show_theme_data.bg_pic && this.show_theme_data.bg_pic_main_color) {
        return this.show_theme_data.bg_pic_main_color
      } else if (this.show_theme_data.bg_color) {
        return this.show_theme_data.bg_color[1]
      } else {
        return ''
      }
    },
    mutedByAdminDialogConfig() {
      return {
        title: '已被静音',
        desc: `如要在此${this.cur_channel_data.mute_room ? '房间' : '频道'}${this.operate_type || '发言'}，请联系房间管理员等人取消对你的麦克风静音`,
        confirm: {
          text: '我知道了',
        },
      }
    },
    isAllowPhoneMic() {
      return process.env.IS_CLIENT // 客户端
        && (this.cur_channel_data.api_type === 'volc' || this.user_account_settings.audio_clear_mode == 1) // trtc需要清晰模式
    },
    noMicTooltip() {
      return `<p style='text-align: center'>未检测到麦克风 !</p>${this.isAllowPhoneMic 
        ? '点击使用手机端作为麦克风' 
        : process.env.IS_CLIENT 
          ? '切换清晰模式后可使用手机端作为麦克风'
          : ''}`
    },
    hasScreenSharePermission() {
      return this.$permission.judge('ScreenShare', this.cur_channel_data)
    },
    screenShareDisableText() {
      if (!this.hasScreenSharePermission) {
        return '没有在此房间进行屏幕共享的权限'
      }
      return ''
    },
    bgmDisableText() {
      if (!this.$permission.judge('PlayBGM', this.cur_channel_data)) {
        return '没有在此房间共享伴奏包的权限'
      } else if (!process.env.IS_CLIENT) {
        return ''
      } else if (this.my_screen_sharing) {
        return '屏幕共享时禁止使用伴奏功能'
      }
      return ''
    },
    laughterDisableText() {
      if (!this.$permission.judge('PlayVoicePack', this.cur_channel_data)) {
        return '没有在此频道播放语音包的权限'
      }
      return ''
    },
    showAudioGuide() {
      if (this.cur_channel_data.channel_id) {
        return this.show_once_task_by_id(ONCE_TASK_TYPES.enter_audio_channel)
      }
      return false
    },
    isLowLevelElectronClient(){
      return process.env.IS_CLIENT && !electronVersionAfter30()
    },
    showMinimalGuide(){
      if (this.isLowLevelElectronClient) return false
      if (this.cur_channel_data.channel_id) {
        return this.show_once_task_by_id(ONCE_TASK_TYPES.use_minimal) && process.env.IS_CLIENT && !!this.user_account_settings.show_minimal_chat
      }
      return false
    },
    pressBtnText() {
      return this.getKeyName(this.setting_data.audio_press_key, 'string', '+')
    },
    speakFreelyAbout(){
      return {
        cur_channel_data: this.cur_channel_data,
        cur_my_roles: this.cur_my_roles,
        cur_roles_list: this.cur_roles_list
      }
    },
    bgmTooltipConfig() {
      let config = {}
      if (this.showBgmLowVerisonTip === true) {
        config.popperClass = 'white'
        config.text = `当前系统版本过低，</br>可能导致共享伴奏失败`
        config.manual = true
        config.show = true
      } else {
        config.text = this.bgmDisableText || '共享伴奏'
      }
      return config
    },
    screenshareTooltipConfig() {
      let config = {}
      if (this.showScreenLowVerisonTip === true) {
        config.popperClass = 'white'
        config.text = `当前系统版本过低，</br>可能导致共享音源失败`
        config.manual = true
        config.show = true
      } else {
        config.text = this.screenShareDisableText
      }
      config.disable = !config.text
      return config
    },
    isInHomePage(){
      const homePageNameList = ['home', 'mini-program']
      return homePageNameList.includes(this.$route.name)
    },
    showFullPanel(){
      return this.isInHomePage ? this.needExpend : true
    },
    showAdvertisementPanel(){
      const result = !!(this.index_task && this.index_task.task_name)
      return result
    },
    wrapperStyle(){
      const style = {}
      const homePageExpend = this.isInHomePage && this.needExpend
      if(homePageExpend){
        const activeHeight = this.showAdvertisementPanel ? this.$refs['advertisement']?.clientHeight || 42 : 0
        const gameBlockHeight = this.is_show_game_display_block ? this.$refs['game-display']?.clientHeight || 60 : 0
        style['height'] = this.voice_panel_height + activeHeight + gameBlockHeight + 'px'
      } else {
        style['height'] = 'auto'
      }
      return style
    },
    showVerfiedNoticeQuery() {
      return this.cur_channel_others_bilibili_living && !this.user_verified
    },
    isOpenVoiceKey() {
      return this.setting_data.isOpenVoiceKey
    },
    checkIsPlayingOfficialGame() {
      if(process.env.IS_CLIENT && this.user_info.pc_state?.game) {
        return this.user_info.pc_state?.game.game_name
      } else {
        return ''
      }
    },
    gameDisplayBlockMatter() {
      return {
        isInHomePage: this.isInHomePage,
        readGameDisplay: this.readGameDisplay,
        gameDisplayInfo: this.gameDisplayInfo,
        needExpend: this.needExpend,
      }
    },
    showScreenShareRewardTip() {
      return this.isShowGetcreenShare && this.getScreenShareData
    },
    isAllowRecord() {
      return this.$permission.judge('AudioRecord', this.cur_channel_data)
    },
    recordTooltipConfig() {
      const time = this.recordingTime
      const config = {
        text: '录制语音(Beta)',
        desc: '单次最长可录制1小时',
      } 
      if (this.is_recording) {
        config.text = `停止录制(${this.getRecordingTimeFormatStr(time)})`
        config.desc = ''
      }
      return config
    },
    recordStopMatter() {
      return [!this.isAllowRecord, this.is_mic_mute]
    },
    micIconHeight() {
      const ICON_HEIGHT = 18
      const height =
        this.user_volumes[this.user_info.user_id] &&
        this.user_volumes[this.user_info.user_id] > 60 &&
        this.setting_data.micLevel
          ? getRtcVolumeIconHeight(
              this.user_volumes[this.user_info.user_id],
              ICON_HEIGHT
            )
          : 0;

      return height
    },
    ...mapGetters([
      'cur_room_data',
      'user_info',
      'is_login',
      'cur_channel_data',
      'setting_data',
      'user_volumes',
      'channel_connecting',
      'rtc_connection',
      'ws_id',
      'old_ws_id',
      'showGlobalConfig',
      'online_state',
      'tip_sound_control',
      'tip_sound_volume',
      'bgm_state',
      'show_theme_data',
      'emphasize_show_theme_bg_color',
      'once_tasks',
      'is_phone_mic_connecting',
      'my_screen_sharing',
      'cur_text_channel_data',
      'show_once_task_by_id',
      'global_switches',
      'user_heybox_id',
      'user_account_settings',
      'anchor_mode',
      'only_text_channel_data',
      'cur_my_roles',
      'cur_roles_list',
      'is_speak_freely',
      'cur_channel_others_bilibili_living',
      'user_verified',
      'global_check_bilibili',
      'index_task',
      'limitations',
      'voice_panel_height',
      'laughter_flatten_list',
      'voice_packs_map',
      'voice_room_list',
      'is_show_game_display_block',
      'is_recording',
      'recording_id',
      'hide_advertisement_panel',
      'enter_channel_ws_connecting_channel_id',
      'is_init_laughter_tracks',
      'channel_sidebar_width',
      'is_mic_mute',
      'is_no_mic',
      'is_earphone_mute',
      'is_press',
      'show_bgm_selector',
      'hosts',
      'host_mode',
    ]),
  },
  methods: {
    ...mapMutations([
      'SET_CUR_CHANNEL_DATA',
      'SET_ANCHOR_MUTE_USER_IDS',
      'SET_ONCE_TASK_LIST',
      'SET_CUR_TEXT_CHANNEL_DATA',
      'SET_GLOBAL_CONFIG',
      'SET_SCREEN_SHARE_CHECK_INFO',
      'SET_USER_VOLUMES',
      'SET_IS_SPEAK_FREELY',
      'SET_VOICE_PACKS_MAP',
      'SET_VOICE_ROOM_LIST',
      'SET_FAVORITE_VOICE_PACK_IDS',
      'SET_LAUGHTER_FLATTEN_LIST',
      'SET_IS_SHOW_GAME_DISPLAY_BLOCK',
      'SET_IS_INIT_LAUGHTER_TRACKS',
      'SET_IS_PRESS',
      'SET_SHOW_BGM_SELECTOR',
      'SET_CHANNEL_HOSTS',
    ]),
    ...mapActions([
      'SET_SETTING_DATA_PARAM',
      'SET_USER_ACCOUNT_SETTINGS',
    ]),
    closeGetScreenTips (openScreenShare) {
      this.isShowGetcreenShare = false
      this.getScreenShareData = null

      if (openScreenShare) {
        this.handleCickOperate('screen')
      }
    },
    showScreenShare (data) {
      data = data.data
      data.award_time = parseInt(data.award_time / 1000 / 60 / 60 / 24)
      this.getScreenShareData = data
      this.isShowGetcreenShare = true
    },
    openMinimalChat () {
      if (process.env.IS_CLIENT) {
        if (this.minimalLock) {
          return
        }
        this.minimalLock = true
        this.checkMinimalVersion().then((res) => {
          this.minimalLock = false
          if (res.status == 'ok') {
            if (this.setting_data.minimal_query_never_show) {
              window.electronAPI.openMinimalChat(this.cur_channel_data.room_id, this.cur_channel_data.channel_id)
              return
            }
            const handleChangeMinimalQueryNeverShow = (val) => {
              this.SET_SETTING_DATA_PARAM({
                'minimal_query_never_show': val
              })
            }
            const data = {
              config:{
                title: '切换至极简模式，体验超低占用',
                confirm: {
                  text: '切换'
                },
                cancel: {
                  text: '取消'
                },
                neverShow: {
                  text: '不再提示'
                },
              },
              confirmCB: ({is_never_show}) => {
                let room_id = this.cur_channel_data.room_id
                let channel_id = this.cur_channel_data.channel_id
                EventBus.$emit('Channel_Access:exitChannel', () => {
                  window.electronAPI.openMinimalChat(room_id, channel_id)
                  is_never_show && handleChangeMinimalQueryNeverShow(is_never_show)
                }, true);
              },
              cancelCB: ({is_never_show}) => {
                is_never_show && handleChangeMinimalQueryNeverShow(is_never_show)
              },
              closeCB: ({is_never_show}) => {
                is_never_show && handleChangeMinimalQueryNeverShow(is_never_show)
              },
            }
            this.$query(data)
          } else {
            this.$toast.error(res.msg)
          }
        }).catch((text) => {
          this.$toast.error(text)
        })
      } else {
        EventBus.$dynamic('ClientRecommend', '极简模式')
      }
    },
    checkMinimalVersion () {
      return new Promise(async (resolve, reject) => {
        let version = await window.electronAPI.getClientVersion()
        // 获取极简模式版本
        getMinimalVersion({
          bit: window.exe_bit,
          asar_version: version.asar_version,
          client_version: version.client_version
        }).then((res) => {
          if (res.data.status === 'ok') {
            let r = res.data.result
            if (r.version && r.file) {
              // 本地校验极简模式文件
              window.electronAPI.checkMinimalFile(r.version, r.file, (r) => {
                resolve(r)
              })
            } else {
              reject('请升级至最新版本')
            }
          } else {
            reject('参数错误')
          }
        }).catch((e) => {
          console.log(e)
          reject('网络错误')
        })
      })
    },
    handleOperate(type) {
      if(!this.is_login){
        return
      }
      if(this.showLaughterSelector && this.$refs['laughter-selector']?.remindSortingTip()) return
      let m = this.setting_data.micLevel,
        v = this.setting_data.voiceLevel
      let last_avaliable = {
        m: this.setting_data.last_avaliable_mic_level || 50,
        v: this.setting_data.last_avaliable_voice_level || 50
      }
      let t_volume = this.tip_sound_volume
      let need_update_last_avaliable = false
      if (type == 'mic') { // 点击麦克风按钮
        if (this.is_mic_mute) { // 优先检测是否被静音
          if(this.limitations){ // 查看是否有限制，如果有限制的回调函数的话 执行 否则不执行
            this.limitations.handleJump && this.limitations.handleJump()
          }else{
            this.handleShowMutedByAdminDialog('发言')
          }
          return
        }
        if (this.is_no_mic) {  // 是否没有麦克风
          if (this.isAllowPhoneMic) { // 是否支持手机麦克风
            EventBus.$emit('set_dialog_visible:PhoneMicConnect')
          }
          return
        }
        if (m == 0) {
          if(!this.is_speak_freely && !this.setting_data.audio_press_mode){
            this.noticeWhenChangeValue({
              newMicLevel: last_avaliable.m,
              successCb: () => {
                this.handleMicTurnOn(v, last_avaliable, t_volume)
              }
            })
            return
          }
          this.handleMicTurnOn(v, last_avaliable, t_volume)
        } else {
          last_avaliable.m = m
          need_update_last_avaliable = true
          this.SET_SETTING_DATA_PARAM({
            micLevel: 0,
          })
          this.tip_sound_control(1) && playAudio(require('_audio/mic-off.mp3'), t_volume)
        }
      } else if (type == 'voice') {
        if (this.is_earphone_mute) {
          this.$query({
            config: {
              title: '已被耳机静音',
              desc: '如要在此房间收听，请联系房间管理员等人取消对你的麦克风静音',
              confirm: {
                text: '我知道了',
              },
            },
          })
          return
        }
        if (v > 0 && m > 0) {
          last_avaliable.m = m
          last_avaliable.v = v
          need_update_last_avaliable = true
          this.SET_SETTING_DATA_PARAM({
            micLevel: 0,
            voiceLevel: 0,
          })
          this._doubleClose = true
          this.tip_sound_control(3) && playAudio(require('_audio/volume-off.mp3'), t_volume)
        } else if (v > 0) {
          last_avaliable.v = v
          need_update_last_avaliable = true
          this.SET_SETTING_DATA_PARAM({
            voiceLevel: 0,
          })
          this.tip_sound_control(3) && playAudio(require('_audio/volume-off.mp3'), t_volume)
        } else if (this._doubleClose) {
          this.SET_SETTING_DATA_PARAM({
            micLevel: last_avaliable.m,
            voiceLevel: last_avaliable.v,
          })
          this._doubleClose = false
          this.tip_sound_control(4) && playAudio(require('_audio/volume-on.mp3'), t_volume)
        } else {
          this.SET_SETTING_DATA_PARAM({
            voiceLevel: last_avaliable.v,
          })
          this.tip_sound_control(4) && playAudio(require('_audio/volume-on.mp3'), t_volume)
        }
      }
      if (need_update_last_avaliable) {
        this.SET_SETTING_DATA_PARAM({
          last_avaliable_mic_level: last_avaliable.m,
          last_avaliable_voice_level: last_avaliable.v,
        })
      }
    },
    changeDevice(type, id) {
      if (type == 'mic') {
        this.$rtc.changeMicDevice(id)
      } else if (type == 'voice') {
        this.$rtc.changeVoiceDevice(id)
      }
    },
    reportUserVoiceState: debounce(function (check) {
      let params = {
        earphone_state: this.setting_data.voiceLevel > 0 ? 1 : 0,
        state: this.setting_data.micLevel > 0 ? 0 : 1
      }
      if (check && JSON.stringify(params) === JSON.stringify(this._userVoiceStateBackup || {})) {
        return
      }
      this._userVoiceStateBackup = params
      if (!this.cur_channel_data.channel_id) return
      reportUserVoiceState({}, {
        ...params,
        channel_id: this.cur_channel_data.channel_id,
        room_id: this.cur_channel_data.room_id,
      })
    }, 100),
    reEnterChannel(retry = true) {
      let room_id = this.cur_channel_data.room_id || this.cur_room_data.room_id,
        channel_id = this.cur_channel_data.channel_id
      if (!room_id && !channel_id) return
      clearTimeout(this._reEnterChannelTimer)
      
      enterChannel(
        {
          room_id,
          channel_id,
          reconnect: 1,
          use_audio: 1,
          old_ws_id: this.old_ws_id
        }
      ).then((res) => {
        if (res.data.status === 'ok') {
          if (res.data.result && res.data.result.refuse_user_audio) {
            EventBus.$emit('Channel_Access:exitChat')
          }
          EventBus.$emit('Update_room_view', () => {
            this.$permission.clearPermissionCache(this.$route.params.room_id)
          }) // 调用进入频道后刷新房间数据，防止出现时序问题
          this.reEnterChannelTimes = 0
        } else if (retry) {
          let base = WS_RECONNECT_ENTER_ROOM_TIMEOUT[this.reEnterChannelTimes]
          this.reEnterChannelTimes ++
          if (this.reEnterChannelTimes > WS_RECONNECT_ENTER_ROOM_TIMEOUT.length) {
            this.$query({
              config: {
                title: '房间重连失败',
                desc: '可能会导致房间内数据更新错误，请尝试手动重连或刷新黑盒语音',
                confirm: {
                  text: '手动重连'
                },
              },
              confirmCB: () => this.reEnterChannel(false)
            })
          } else {
            this._reEnterChannelTimer = setTimeout(() => {
              this.reEnterChannel()
            }, getRandom(base - 2000, base + 2000))
          }
        }
      })
    },
    handleShowMutedByAdminDialog(type = '') {
      if (this.is_mic_mute) {
        this.operate_type = type || '发言'
        this.$query({
          config: this.mutedByAdminDialogConfig,
        })
      }
      return this.is_mic_mute
    },
    jumpRoom() {
      let room_id = this.cur_channel_data.room_id
      if (this.cur_text_channel_data.room_id === room_id) { // 如果要跳转的房间存在文字频道，清除文字频道状态，确保回到房间时展示语音频道
        this.SET_CUR_TEXT_CHANNEL_DATA({})
      }
      if (this.$route.params.room_id === room_id) {
        EventBus.$emit('ChannelSidebar:Scroll_Channel_To_Center', this.cur_channel_data.channel_id, false)
      } else {
        this.$router.push({ name: 'room', params: { room_id: room_id } })
      }
      EventBus.$emit('ScrollRoomBarToCenter', room_id, 'center')
    },
    copyId() {
      try {
        copyText(this.user_info.user_id)
        this.$toast.success('复制成功')
      } catch (error) {
        this.$toast.error('复制失败')
      }
    },
    startTimeInterval() {
      if (this.calLoop) {
        clearInterval(this.calLoop)
      }
      let _this = this
      let loopFunc = function () {
        if(document.hasFocus()) {
          _this.remainHour = String(parseInt(_this.time_remaining / 60 / 60)).padStart(2, '0')
          if (_this.remainHour === '00') {
            _this.remainHour = ''
          }
          _this.remainMin = String(parseInt(_this.time_remaining / 60) % 60).padStart(2, '0')
          _this.remainSec = String(_this.time_remaining % 60).padStart(2, '0')
          let isInCurChannelRoom = _this.cur_channel_data.room_id === _this.cur_room_data.room_id
          if (isInCurChannelRoom && _this.remainMin >= 30 && !_this.addFriendLock && !_this.setting_data.never_show_add_channel_friends) {
            _this.handleShowAddStrangerTip()
          }
        }
        _this.time_remaining++
        if (_this.is_recording) {
          _this.recordingTime++
        } else {
          if(_this.recordingTime !== 0) {
            _this.recordingTime = 0
          }
        }
      }
      loopFunc()
      _this.calLoop = setInterval(loopFunc, 1000)
    },
    checkIsStranger(member) {
      if (member.user_id == this.user_info.user_id) return false
      return !member.is_friend
    },
    addAllChannelFriends() {
      if (!this.cur_channel_data.members || this._add_all_channel_friend_lock) return
      let channelStrangers = this.channelStrangers
      if (channelStrangers.length == 0) return
      this._add_all_channel_friend_lock = true
      reportData('add-friend', {
        pos: 'add-in-channel-users',
      })
      addFriend({}, {
        friend_ids: channelStrangers.map(member => member.user_id),
        source: ADD_VOICE_PANEL_ALL,
      }).then((res) => {
        this._add_all_channel_friend_lock = false
        this.channelStrangers = []
        if (res.data.status === 'ok') {
          this.$toast.success('发送成功')
        }
      })
    },
    mineContextMenuHandler(event) {
      this.$contextmenu({
        groups: [
          {
            items: [
              {
                component: 'menu-button',
                data: {
                  label: '复制小黑盒ID: ' + this.user_info.user_id,
                  icon: 'icon-reduction-bold1',
                },
                onClick: () => {
                  this.copyId()
                },
              },
              {
                component: 'menu-button',
                data: {
                  label: '退出登录',
                  type: 'warn',
                },
                onClick: () => {
                  this.$query({
                    config: {
                      title: '退出登录?',
                      desc: '退出后不会删除历史数据，下次登录依然可以使用本账号',
                      confirm: {
                        text: '退出',
                        type: 'alert'
                      },
                      cancel: {
                        text: '取消',
                      },
                    },
                    confirmCB: this.logout,
                  })
                },
              },
            ],
          },
        ],
        event,
      })
      return false
    },
    // 房间或频道删除时的处理
    handleRoomChannelDelete(data) {
      let d = data.data
      if (d.channel_id && d.channel_id == this.cur_channel_data.channel_id) {
        // 防止从临时频道切换至其他频道时由于收到频道删除推送导致意外退出频道
        if (!(this.enter_channel_ws_connecting_channel_id && this.enter_channel_ws_connecting_channel_id !== d.channel_id)) {
          this.$rtc.leave(() => {
            this.SET_CUR_CHANNEL_DATA({})
            this.SET_USER_VOLUMES({});
            this.$toast.error('频道已解散')
          })
        }

      } else if ((!d.channel_id && d.room_id == this.cur_channel_data.room_id)) {
        this.$rtc.leave(() => {
          this.SET_CUR_CHANNEL_DATA({})
          this.SET_USER_VOLUMES({});
        })
      }
    },
    hidenPover() {
      this.$refs['mic-popover'].hidden()
      this.$refs['voice-popover'].hidden()
      this.$refs['ai-denoiser-popover'].hidden()
    },
    handlePressMic(isOpen) {
      clearTimeout(this._pressMicTimer)
      if (isOpen) {
        this.pressMicFunc(isOpen)
      } else {
        if (typeof this.setting_data.audio_press_delay === 'number' && this.setting_data.audio_press_delay) {
          this._pressMicTimer = setTimeout(() => {
            this.pressMicFunc(isOpen)
          }, this.setting_data.audio_press_delay)
        } else {
          this.pressMicFunc(isOpen)
        }
      }
    },
    pressMicFunc(isOpen) {
      let playingAudio = this.is_press !== isOpen
      this.SET_IS_PRESS(isOpen)
      this.$rtc.setMuted(!isOpen)
      let volume = this.tip_sound_volume
      if (playingAudio) { // 如果is_press没变化不需要声音提示
        if (isOpen) {
          this.tip_sound_control(9) && playAudio(require("_audio/key-talk-start.mp3"), volume)
        } else {
          this.tip_sound_control(10) && playAudio(require("_audio/key-talk-end.mp3"), volume)
        }
      }

    },
    handleUserVoice(data) {
      let d = data.data
      if (d.user_id != this.user_info.user_id && this.cur_channel_data.members) {
        let volume = this.tip_sound_volume
        let hasTipSound = this.cur_channel_data.channel_id && (this.cur_channel_data.members.length < this.cur_channel_data.tip_sound_user_limit)
        if (d.state == 1) {
          if (hasTipSound && this.tip_sound_control(7)) {
            // 如果是未实名用户，在有主播进入时播放特殊的音频
            if (this.global_check_bilibili && !this.user_verified && d.bilibilier) {
              playAudio(require("_audio/bilibili-living-verify-warn.mp3"), volume)
            } else {
              playAudio(require("_audio/other-user-join.mp3"), volume)
            }
          }
        } else {
          if (hasTipSound && this.tip_sound_control(8)) {
            playAudio(require("_audio/other-user-exit.mp3"), volume)
          }
        }
      }
    },
    handleNetworkQuality(q) {
      this.networkQuality = q
    },
    handleStatistics(q) {
      this.statisticsQuality = q
    },
    registerShortcuts() {
      shortcut.addShortcut({
        need_config: ['audio_press_mode'],
        key_config: 'audio_press_key',
        deliver_key_up: true,
      }, this.handlePressMic)
      this._shortcut_mic = () => { this.handleOperate('mic') }
      this._shortcut_voice = () => { this.handleOperate('voice') }
      shortcut.addShortcut({ key_config: 'mic_switch_key' }, this._shortcut_mic)
      shortcut.addShortcut({ key_config: 'voice_switch_key' }, this._shortcut_voice)
      shortcut.addShortcut({ key_config: 'anchor_mode_key' }, this.changeAnchorMode)
    },
    unregisterShortcuts() {
      shortcut.removeShortcut('audio_press_key')
      shortcut.removeShortcut('mic_switch_key')
      shortcut.removeShortcut('voice_switch_key')
      shortcut.removeShortcut('anchor_mode_key')
    },
    handleShowVoiceCloseTip(isPress) {
      if (this._showVoiceCloseTipLock && !isPress) return
      this.showVoiceCloseTip = true
      this._showVoiceCloseTipLock = true
    },
    handleHideVoiceCloseTip() {
      if (!this.showVoiceCloseTip) return
      this.showVoiceCloseTip = false
    },
    handleRefuseAudio() {
      EventBus.$emit('Channel_Access:exitChat')
      this._refuseAudioDialogShow = true
      this.$query({
        config: {
          title: '当前设备语音已断开',
          desc: '已在另一设备开麦',
          confirm: {
            text: '我知道了',
          },
          cancel: {
            text: '切换为当前设备',
          },
          className: 'refuse-audio-dialog'
        },
        cancelCB: () => {
          this.snatchMicHandler()
        },
        closeCB: () => {
          this._refuseAudioDialogShow = false
        }
      })
    },
    openAIDenoiserConfig(e) {
      if(!this.is_login){
        return
      }
      if(this.showLaughterSelector && this.$refs['laughter-selector']?.remindSortingTip()) return
      e.stopPropagation()
      EventBus.$dynamic('UserConfig', 'audio')
    },
    async handleCickOperate(type) {
      if(this.showLaughterSelector && this.$refs['laughter-selector']?.remindSortingTip()) return
      if (this.is_mic_mute) {
        if (type === 'bgm') {
          this.handleShowMutedByAdminDialog('播放伴奏')
          return
        } else if (type === 'record') {
          this.handleShowMutedByAdminDialog('录制语音')
          return
        }
      }
      if (this.isHostBanned) {
        this.$toast.error('请先上麦')
        return
      }
      if(this.limitations?.tooltip) {
        if(type === 'record') {
          this.$query({
            config: {
              title: '已被静音',
              desc: `如要在此房间录制语音，请联系房间管理员等人取消对你的麦克风静音`,
              confirm: {
                text: '我知道了',
              },
            }
          })
          return
        }
      }
      if (type === 'bgm') {
        if (this.bgmDisableText) {
          return
        } else {
          if (process.env.IS_CLIENT) {
            this.SET_SHOW_BGM_SELECTOR(true)
          } else {
            EventBus.$dynamic('ClientRecommend', '共享伴奏')
          }
        }
      } else if (type === 'laughter') {
        if (this.laughterDisableText) return
        const newShowLaughterSelector = !this.showLaughterSelector
        this.changeShowLaughterSelector(newShowLaughterSelector)
      } else if (type === 'screen') {
        if (this.screenShareDisableText) return
        if (this.my_screen_sharing) {
          this.$query({
            config: {
              title: "确定停止屏幕共享？",
              confirm: {
                text: "停止",
                type: "alert",
              },
              cancel: {
                text: "取消",
              },
            },
            confirmCB: () => {
              this.$rtc.stopScreenCapture();
            },
            
          });
        } else {
          let res = await checkScreenShare({
            room_id: this.cur_channel_data.room_id,
            channel_id: this.cur_channel_data.channel_id,
          })
          if (res.data.status === 'ok') {
            this.SET_GLOBAL_CONFIG({
              screenshare_options: res.data.result.options
            })
            this.SET_SCREEN_SHARE_CHECK_INFO(res.data.result)
            this.$nextTick(() => {
              this.$rtc.handleScreenShare()
            })
          }
        }
      } else if (type === 'record') {
        // 判断是否为线路一 当前Volc不支持含有汉字的文件绝对路径，因此暂时不允许volc的线路使用这个功能
        if(process.env.IS_CLIENT) {
          // 只有线路1的时候 需要开启清晰模式后才能使用录音功能
          this.$refs['record-popover']?.hidden()
          if(this.cur_channel_data.api_type === 'trtc' && !this.user_account_settings.audio_clear_mode) {
            this.$query({
              config: {
                title: '需开启清晰模式后使用',
                confirm: {
                  text: '去开启',
                },
                cancel: {
                  text: '取消',
                }
              },
              confirmCB: () => {
                this.$rtc.handleChangeClearMode(1)
                this.changeRecordStatus()
              }
            })
            return
          } else {
            this.changeRecordStatus()
          }
        } else {
            EventBus.$dynamic('ClientRecommend', '录制语音')
        }
      }
    },
    async changeShowLaughterSelector(show, pos = null) {
      if(show && !this.is_init_laughter_tracks) {
        await this.initLaughter()
      }
      this.showLaughterSelector = show
      // 如果关闭语音包，则清空位置
      if(!show) {
        this.laughterCalPos = null
      } else {
        this.laughterCalPos = pos
      }
    },
    // 用户信息更新推送
    handleUserStateUpdate(data) {
      let d = data.data
      // 仅判断自己的状态变化
      if (d.channel_id == this.cur_channel_data.channel_id && d.user_id == this.user_info.user_id) {
        let muted = d.mute // 用户被静音
          || d.mute_room // 用户被房间静音
        let muteStateChange = false
        // 判断是否被管理员静音
        if (d.mute && !this.cur_channel_data.mute) {
          this.$toast.error("您已被管理员静音");
          // 如果正在使用bgm功能需要停止系统捕获，如果正在使用屏幕共享的话不需要停止系统捕获，屏幕共享和bgm功能功能互斥，因此不需要判断屏幕共享的状态
          if (this.bgm_state.isStart) {
            this.trtcSystemAudioChange(false)
          }
          muteStateChange = true
        } else if (!d.mute && this.cur_channel_data.mute) {
          this.$toast.success("您已被管理员解除静音");
          muteStateChange = true
        }

        // 判断是否被房间静音
        if (d.mute_room && !this.cur_channel_data.mute_room) {
          this.$toast.error("您已被管理员房间静音");
          // 如果正在使用bgm功能需要停止系统捕获，如果正在使用屏幕共享的话不需要停止系统捕获，屏幕共享和bgm功能功能互斥，因此不需要判断屏幕共享的状态
          if (this.bgm_state.isStart) {
            this.trtcSystemAudioChange(false)
          }
          muteStateChange = true
        } else if (!d.mute_room && this.cur_channel_data.mute_room) {
          this.$toast.success("您已被管理员解除房间静音");
          muteStateChange = true
        }
        if (muteStateChange) {
          this.$rtc.setMuteBanned(muted)
        }

        // 判断是否被耳机静音
        if (d.mute_earphone && !this.cur_channel_data.mute_earphone) {
          this.$toast.error("您已被管理员耳机静音");
          this.$rtc.setEarphoneBanned(d.mute_earphone)
        } else if (!d.mute_earphone && this.cur_channel_data.mute_earphone) {
          this.$toast.success("您已被管理员解除耳机静音");
          this.$rtc.setEarphoneBanned(d.mute_earphone)
        }
        this.SET_CUR_CHANNEL_DATA({
          ...this.cur_channel_data,
          mute: d.mute,
          mute_room: d.mute_room,
          mute_earphone: d.mute_earphone,
        })
      }
    },
    handleReEnterChannel(target_channel) {
      // 检测是否语音线路发生变化，是的话重新加入频道
      if (this.cur_channel_data.rtc_api_type !== target_channel.api_type) {
        let _cur_channel_data = JSON.parse(JSON.stringify(this.cur_channel_data))
        EventBus.$emit('Channel_Access:reEnterChannel', {
          ..._cur_channel_data,
          ...target_channel
        });
      }
    },
    // 房间信息更新
    async handleRoomUpdateInfo(data) {
      let d = data.data
      let target_channel = findChannelSync(this.cur_channel_data.channel_id, d.channels)
      if (!target_channel) return

      // 检测主持人模式是否有变化
      await this.handleCheckHostModeBanned(target_channel)

      // 检测是否语音线路发生变化，是的话重新加入频道
      this.handleReEnterChannel(target_channel)
    },
    async handleSingleChannelUpdate(data) {
      let target_channel = data.data.channel
      if (!target_channel || target_channel.channel_id !== this.cur_channel_data.channel_id) return
      
      // 检测主持人模式是否有变化
      await this.handleCheckHostModeBanned(target_channel)
      
      this.handleReEnterChannel(target_channel)
    },
    changeMicLevel: function (level) {
      if(!this.is_speak_freely && !this.setting_data.audio_press_mode) return
      this.SET_SETTING_DATA_PARAM({
        micLevel: level
      })
    },
    changeVoiceLevel: function (level) {
      this.SET_SETTING_DATA_PARAM({
        voiceLevel: level
      })
    },
    userCardMenu(e, type, user) {
      if(this.showLaughterSelector && this.$refs['laughter-selector']?.remindSortingTip()) return
      if (this.showUserCardGuide) {
        user.force_show_tooltip = true
        setTimeout(() => {
          this.finishUserCardGuide()
        }, 0)
      }
      if (this.cur_room_data.room_id) {
        user = {
          ...user,
          roles: this.cur_my_roles
        }
      }
      EventBus.$emit('User_Menu:card', e, type, user);
    },
    finishUserCardGuide() {
      const task = this.once_tasks.find(item => item.task_id == ONCE_TASK_TYPES.user_card_guide)
      if (task) {
        task.finished = 1
        this.SET_ONCE_TASK_LIST(this.once_tasks)
        completeOnceTaskV2({ _notip: 1 }, {
          task_id: task.task_id,
        })
      }
    },
    async handleHangUp() {
      if (window.client_env !== 'electron') {
        const is_used_chat = await getStorage("is_used_chat")
        if (!is_used_chat) {
          EventBus.$emit('Show_Download_Client_Dialog', true)
          setStorage('is_used_chat', 1)
        }
      }
      this.exitChannelHandler()
    },
    exitChannelHandler(isNeedAxios) {
      EventBus.$emit('Channel_Access:exitChannel', () => {
        this._showVoiceCloseTipLock = false
      }, isNeedAxios);
      this.handleMouseLeaveWrapper()
    },
    snatchMicHandler(func) {
      EventBus.$emit('Channel_Access:snatchMic', func);
    },
    handleJoinChannel() {
      if (this.only_text_channel_data.channel_id) {
        EventBus.$emit('Channel_Access:enterChannel', {
          channel: this.only_text_channel_data,
        })
      }
    },
    checkDeviceAutoEllipsis(bl, children) {
      if (bl) {
        findChildComponents(children, 'Tooltip').forEach(v => {
          v.checkAutoEllipsis()
        })
      }
    },
    handleChannelUserUpdate(data) {
      // 如果已经被抢麦，而且同频道有和当前用户id一致的用户退出频道，清除当前在频道中的状态
      let d = data.data, move_type = d.move_type

      if (move_type === CHANNEL_USER_UPDATE_MOVE_TYPE.LEAVE
        && d.channel_id === this.cur_channel_data.channel_id
        && d.member.user_id == this.user_info.user_id
        && this.cur_channel_data.refuse_user_audio
        && !d.preempt_ws_ids.includes(this.ws_id)
        ) {
        this.exitChannelHandler(false)
        if (this._refuseAudioDialogShow) {
          EventBus.$emit('QueryDialog_Close')
        }
      }
    },
    infoPreLoad(key){
      return getCookie(key)
    },
    async isChecking() {
      this.isCheckingLogin = true
      await checkLoginStatusAsync()
      this.isCheckingLogin = false
    },
    changeAnchorMode() {
      let v = this.anchor_mode ? 0 : 1
      this.SET_USER_ACCOUNT_SETTINGS({
        anchor_mode: v,
      })
      updateAccountSetting({}, {
        setting: 'anchor_mode',
        value: v
      })
      muteCurChannelUserVoice()
    },
    handleAIDenoiserVersionMenu(v) {
      clearTimeout(this._hideAiIenoiserVersionMenuTimer)
      this._hideAiIenoiserVersionMenuTimer = null
      if (v) {
        this.showAIDenoiserVersionMenu = true
      } else {
        clearTimeout(this._hideAiIenoiserVersionMenuTimer)
        clearTimeout(this._hideAiIenoiserTypeMenuTimer)
        this._hideAiIenoiserVersionMenuTimer = setTimeout(() => {
          this.showAIDenoiserVersionMenu = false
          this.showAIDenoiserTypeMenu = false
        }, 300)
      }
    },
    handleAIDenoiserTypeMenu(showMenu, itemVal) {
      clearTimeout(this._hideAiIenoiserTypeMenuTimer)
      if (showMenu) {
        this.showAIDenoiserTypeMenu = true
        this.aiDenoiserHoverVal = itemVal
      } else {
        this.aiDenoiserHoverVal = -1
        this._hideAiIenoiserTypeMenuTimer = setTimeout(() => {
          this.showAIDenoiserTypeMenu = false
        }, 300)
      }
    },
    changeShowPopIcon(){
      if(this.showAudioGuide){
        this.showGuideIcon = false
        return
      }
      this.showMinimalGuideIcon = false
      this.showGuideIcon = false
    },
    handleVoicePanelContextMenu(event) {
      if(!this.cur_channel_data.channel_id) return 
      const minimal_obj = {
        component: 'menu-switch',
        data: {
          label: '显示极简模式',
          value: !!this.user_account_settings.show_minimal_chat
        },
        onClick: () => {
          const newValue = !!this.user_account_settings.show_minimal_chat ? 0 : 1
          minimal_obj.data.value = !!newValue
          this.SET_USER_ACCOUNT_SETTINGS({
            show_minimal_chat: newValue
          })
          updateAccountSetting({}, {
            setting: 'show_minimal_chat',
            value: newValue
          })
        },
      }
      
      let optionList = [
          minimal_obj,
      ]
      this.$contextmenu({
          groups: [
            {
              items: optionList
            },
          ],
          event,
        })
    },
    noticeSpeakNotFreely(result) {
      // watch中去监听是否能够自由说话 主要影响的是频道、权限组和个人的权限
      this.SET_IS_SPEAK_FREELY(result)
      // 如果是可以直接说话，那么看之前是否因为权限问题不可以直接说话，重新设置pressMode
      if (result) {
        this.speakFreelyLock = false
        return
      }
      if (this.speakFreelyLock || this.setting_data.audio_press_mode || !this.setting_data.micLevel) return
      this.tempMicLevel = this.setting_data.micLevel 
      this.SET_SETTING_DATA_PARAM({
        micLevel: 0,
      })
      let reply = false
      this.$query({
        config: {
          title: '当前频道需要使用按键说话',
          confirm: {
            text: '使用按键说话'
          },
          cancel: {
            text: '取消'
          },
        },
        confirmCB: () => {
          this.speakFreelyLock = true
          this.SET_SETTING_DATA_PARAM({
            audio_press_mode: true,
            micLevel: this.tempMicLevel
          })
          reply = true
        },
        cancelCB: () => {
          this.speakFreelyLock = true
          this.SET_SETTING_DATA_PARAM({
            last_avaliable_mic_level: this.setting_data.micLevel,
            micLevel: 0,
            audio_press_mode: false
          })
          reply = true
        },
        closeCB: () => {
          if(this.speakFreelyLock) return
          
          this.speakFreelyLock = true

          if(!reply){
            this.SET_SETTING_DATA_PARAM({
              micLevel: 0
            })
            return
          }
          this.tempMicLevel = 0

          if(this.setting_data.audio_press_mode) {
            return
          } else {
            this.SET_SETTING_DATA_PARAM({
              last_avaliable_mic_level: this.setting_data.micLevel,
              micLevel: 0,
            })
          }
        },
      })
    },
    noticeWhenChangeValue({ successCb, failCb, newMicLevel, newPressMode } = {}) {
      this.$refs['mic-popover']?.hidePopover()
      this.speakFreelyLock = false;
      // 如果不可以自由说话，那么提示需要使用按键说话
      const queryConfig = this.getNoticeConfig({ newMicLevel, newPressMode, successCb, failCb })
      this.$query(queryConfig)
    },
    handleSwitchAudioPressMode() {
      const newValue = !this.setting_data.audio_press_mode
      // 如果可以自由说话，那么直接切换
      if(this.is_speak_freely){
        this.SET_SETTING_DATA_PARAM({ audio_press_mode: newValue })
      }else{
        // 如果是闭麦状态下 则可以随便更新audio_press_mode
        if(!this.setting_data.micLevel){
          this.SET_SETTING_DATA_PARAM({ audio_press_mode: newValue })
        }else{
          // 否则提示需要使用按键说话
          this.noticeWhenChangeValue({ newPressMode: newValue })
        }
      }
    },
    handleMicLevelChange(v){
      this.$rtc.changeOperationMic(v)
      this.reportUserVoiceState(true)
      if (v) {
        this.showVoiceCloseTip = false
      }
    },
    getNoticeConfig({ newMicLevel, newPressMode, successCb, failCb}){
      if(this.speakFreelyLock) return
      let reply = false
      const queryConfigMap = {
        [SPEAK_FREELY_QUERY_CONFIG_TYPE_MAP.OPEN]: () => ({
          config: {
            title: '当前频道需要使用按键说话',
            confirm: {
              text: '使用按键说话'
            },
            cancel: {
              text: '取消'
            },
          },
          confirmCB: () => {
            this.SET_SETTING_DATA_PARAM({
              audio_press_mode: true,
              micLevel: this.tempMicLevel
            })
            reply = true
            successCb && successCb()
          },
          cancelCB: () => {
            this.SET_SETTING_DATA_PARAM({
              micLevel: 0,
              audio_press_mode: false,
            })
            reply = true
            failCb && failCb()
          },
          closeCB: () => {
            this.speakFreelyLock = true
            if(!reply){
              this.SET_SETTING_DATA_PARAM({
                micLevel: 0,
                audio_press_mode: false,
              })
            }
            this.tempMicLevel = 0
          },
        }),
        [SPEAK_FREELY_QUERY_CONFIG_TYPE_MAP.CLOSE]: () => ({
          config: {
            title: '当前频道需要使用按键说话，关闭后将自动闭麦，是否关闭',
            confirm: {
              text: '关闭按键说话'
            },
            cancel: {
              text: '取消'
            },
          },
          confirmCB: () => {
            this.SET_SETTING_DATA_PARAM({
              audio_press_mode: false,
            })
            reply = true
            successCb && successCb()
          },
          cancelCB: () => {
            this.SET_SETTING_DATA_PARAM({
              audio_press_mode: true,
            })
            reply = true
            failCb && failCb()
          },
          closeCB: () => {
            this.speakFreelyLock = true
            // 如果还是按键说话则恢复
            if(this.tempMicLevel && this.setting_data.audio_press_mode){
              this.SET_SETTING_DATA_PARAM({
                micLevel: this.tempMicLevel,
              })
            }
            if(!reply){
              return 
            }
            this.tempMicLevel = 0

            // 根据不同的按键模式状态修改麦克风的数据
            if(this.setting_data.audio_press_mode) {
              return
            } else {
              this.SET_SETTING_DATA_PARAM({
                last_avaliable_mic_level: this.setting_data.micLevel,
                micLevel: 0,
              })
            }
          },
        })
      }
      const str = (newPressMode || newMicLevel) ? SPEAK_FREELY_QUERY_CONFIG_TYPE_MAP.OPEN : SPEAK_FREELY_QUERY_CONFIG_TYPE_MAP.CLOSE
      if(str !== SPEAK_FREELY_QUERY_CONFIG_TYPE_MAP.CLOSE || newPressMode === false){
        this.tempMicLevel = this.setting_data.micLevel 
        this.SET_SETTING_DATA_PARAM({
          micLevel: 0
        })
      }
      return queryConfigMap[str]()
    },
    handleMouseEnterDenoiser(item, isEnter = true) {
      if(item.options === 'type') {
        this.handleAIDenoiserTypeMenu(isEnter, item.value)
      }
    },
    handleMouseTypeMenu(enter) {
      if (enter) {
        clearTimeout(this._hideAiIenoiserTypeMenuTimer)
      }
      this.aiDenoiserHoverVal = enter ? TRTC_AI_DENOISER_VERSION_VALUE_MAP.v3 : -1
    },
    showBgmHookWarn(type) {
      switch(type) {
        case 'bgm':
          this.showBgmLowVerisonTip = true
          let bgmFunc = () => {
            this.showBgmLowVerisonTip = false
            window.removeEventListener("click", bgmFunc)
          }
          window.addEventListener("click", bgmFunc)
          break
        case 'screenshare':
          this.showScreenLowVerisonTip = true
          let screenFunc = () => {
            this.showScreenLowVerisonTip = false
            window.removeEventListener("click", screenFunc)
          }
          window.addEventListener("click", screenFunc)
          break
        default:
          break
      }
    },
    handleMicTurnOn(v, last_avaliable, t_volume) {
      if((this._doubleClose || v == 0)){
        // 如果是双关的情况下
        this.SET_SETTING_DATA_PARAM({
          micLevel: last_avaliable.m,
          voiceLevel: last_avaliable.v
        })
        this._doubleClose = false
        this.tip_sound_control(2) && playAudio(require('_audio/mic-on.mp3'), t_volume)
      } else {
        this.SET_SETTING_DATA_PARAM({micLevel: last_avaliable.m})
        this.tip_sound_control(2) && playAudio(require('_audio/mic-on.mp3'), t_volume)
      }
    },
    handleCheckSpeakFreely(e){
      if(!this.is_speak_freely && !this.setting_data.audio_press_mode){
        e.stopPropagation()
        this.noticeWhenChangeValue({
          newMicLevel: 1,
        })
        return 
      }
    },
    handleMouseEnterWrapper(e) {
      this.mouseInWrapper = true
      this.updateNeedExpend(true)
    },
    handleMouseLeaveWrapper() {
      if(
        this.showLaughterSelector || 
        (this.is_show_game_display_block && !this.readGameDisplay)
      ) return
      this.mouseInWrapper = false
      this.updateNeedExpend(false)
    },
    // 防抖更新needExpend, 50ms防抖防止光标进入popover时导致面板缩放
    updateNeedExpend: debounce(function (v){
      // 如果没有正在进行中的更新， 并且要更新的值和当前值相同，则不更新
      if (!this._expendedTimer && v === this.needExpend) return
      // 如果有正在进行中的更新， 并且要更新的值和即将更新值相同，则不更新
      if (this._expendedTimer && v === this._wait_update_need_expend) return

      clearTimeout(this._expendedTimer)
      // 记录即将更新的值
      this._wait_update_need_expend = v

      // needExpend 为true时， 设置module-expend类名, 使面板宽高为展开时宽高，否则为收缩时宽高
      // inHomeExpendAnimation 影响动画类名，为expend时设置展开动画类名，为collapse时设置收缩动画类名，空则不设置动画类名
      // 1. 如果是从收缩 => 展开，
      // 先清空inHomeExpendAnimation，然后延时300ms同时设置 needExpend 和 inHomeExpendAnimation = expend
      // 使宽高为展开时宽高的同时进行展开动画
      // 2. 如果是从展开 => 收缩，
      // 先设置inHomeExpendAnimation = collapse，执行收缩动画
      // 等300ms动画结束后，设置 needExpend = false，使宽高为收缩状态
      this.inHomeExpendAnimation =  v ? '' : 'collapse'
      this._expendedTimer = setTimeout(() => {
        this._wait_update_need_expend = null
        this._expendedTimer = null
        if (v !== this.needExpend) {
          this.needExpend = v
          this.inHomeExpendAnimation = v ? 'expend' : ''
        }
      }, 300)
    }, 20),
    clearExpendedTimer(){
      if(this._setAfterExpended) clearTimeout(this._setAfterExpended)
    },
    handleHoverPopover(hovering){
      this.isHoveringPopover = hovering
      // 如果鼠标不在Popover或者语音组件中，则收起
      if(!hovering && !this.mouseInWrapper){
        this.updateNeedExpend(false)
      } else {
        this.updateNeedExpend(true)
      }
    },
    handleSendLaughterShortcut(isDown, path) {
      if (!this.isOpenVoiceKey) return
      if (this.is_mic_mute) {
        EventBus.$emit('set_dialog_visible:mutedByAdmin', '播放语音包')
        return
      }
      if (isDown && this.cur_channel_data.channel_id) {
        for (let flat of this.laughter_flatten_list) {
          if (flat.list) {
            for (let data of flat.list) {
              if (data.path === path) {
                sendSoundMessage({}, {
                  room_id: this.cur_channel_data.room_id,
                  channel_id: this.cur_channel_data.channel_id,
                  path: data.path,
                  name: data.name,
                  ext: data.ext,
                  volume: data.volume
                })
                this.$refs['laughter-selector']?.setPlayingPath(data.path)
                clearTimeout(this.playing_timer)
                this.playing_timer = setTimeout(() => {
                  this.$refs['laughter-selector']?.setPlayingPath('')
                }, data.duration * 1000)
                return
              }
            }
          }
        }
      }
    },
    async initLaughter() {
      if(!await checkLoginStatusAsync()) return
      
      let res = await getUserLaughterTracks({
        room_id: this.cur_channel_data.room_id
      })
      if(res.data.status == 'ok') {
        let { rooms, voice_packs } = res.data.result
        let vp_keys = Object.keys(voice_packs)
        this.SET_VOICE_ROOM_LIST(rooms?.filter(room => vp_keys.includes(room.room_id)))
        this.SET_VOICE_PACKS_MAP(voice_packs)
        const afterFlattenList = this.flattenList(voice_packs)
        this.SET_LAUGHTER_FLATTEN_LIST(afterFlattenList)
        this.SET_IS_INIT_LAUGHTER_TRACKS(true)
      }
    },
    flattenList(voice_packs, need_add = true) {
      let vp_keys = Object.keys(voice_packs)
      let room_ids = this.voice_room_list.map(room => room.room_id)
      
      let res = []
      if(vp_keys.find(v => v == this.user_info.user_id)) {
        res.push({
          id: LAUGHTER_SPECIAL_GROUP_TYPE.FAVORITE,
          type: 'title',
          text: '收藏',
          icon: 'icon-collect',
        })
        let my_list = voice_packs[this.user_info.user_id]
        my_list.forEach((item, index) => {
          item.group_type = LAUGHTER_SPECIAL_GROUP_TYPE.FAVORITE
          item.index = index
        })

        this.SET_FAVORITE_VOICE_PACK_IDS(my_list.map(item => item.path))
        if(my_list.length < 50) {
          if(my_list[0]?.type !== LAUGHTER_SPECIAL_ITEM_TYPE.ADD){
            my_list.unshift({
              type: LAUGHTER_SPECIAL_ITEM_TYPE.ADD,
              id: 'add-laughter',
              path: 'add-laughter',
            })
          }
        }
        res = res.concat(this.devideLaughter(my_list))
      }
      if(vp_keys.includes(LAUGHTER_SPECIAL_GROUP_TYPE.DEFAULT)) {
        res.push({
          id: LAUGHTER_SPECIAL_GROUP_TYPE.DEFAULT,
          type: 'title',
          text: '黑盒语音',
          icon: 'icon-logo',
        })
        const list = voice_packs[LAUGHTER_SPECIAL_GROUP_TYPE.DEFAULT]
        list.forEach(item => {
          item.group_type = LAUGHTER_SPECIAL_GROUP_TYPE.DEFAULT
        })
        res = res.concat(this.devideLaughter(list))
      }
      room_ids.forEach(key => {
        let room_index = getIndexFromArrayByKeyValue(this.voice_room_list, 'room_id', key)
        let room_laughter_list = voice_packs[key]
        const room = this.voice_room_list[room_index]
        res.push({
          id: key,
          type: 'title',
          text: room.name,
          icon: room.avatar,
        })
       
        if (room_laughter_list) {
          room_laughter_list.forEach(item => {
            item.group_type = key
          })
          res = res.concat(this.devideLaughter(room_laughter_list))
        }
        
        if (need_add && room.manage) {
          const last = res[res.length - 1] 
          if (last && last.list && last.list.length) {
            if (last.list.length == 1) {
              last.list.push({
                type: LAUGHTER_SPECIAL_ITEM_TYPE.ADD,
                id: 'add-laughter-' + room.room_id,
                target_room_id: room.room_id,
                room_name: room.name,
                path: 'add-laughter',
              })
            } else if (last.list.length == 2) {
              res.push({
                type: 'group',
                id: 'group-add-laughter-' + room.room_id,
                list: [{
                  type: LAUGHTER_SPECIAL_ITEM_TYPE.ADD,
                  id: 'add-laughter-' + room.room_id,
                  target_room_id: room.room_id,
                  room_name: room.name,
                  path: 'add-laughter',
                }],
              })
            }
          }
        }
      })
      this.$refs['laughter-selector']?.checkShowLaughterTip(res)
      return res
    },
    devideLaughter(voice_list) {
      let length = voice_list.length
      let size = 3
      let result = []
      for(let i = 0; i < length; i += size) {
        let line_list = voice_list.slice(i, i + size)
        if(line_list.length == 0) break;
        result.push({
          type: 'group',
          id: line_list[0].path,
          list: line_list,
        })
      }
      return result
    },
    async handleRefreshUserLaughter(cb = null) {
      await this.initLaughter()
      cb && cb()
    },
    handleNoticeEndRoomAct(data) {
      const actData = data.data
      EventBus.$dynamic('ExitChannelNoticeDialog', { actData })
    },
    async initGameDisplayBlock() {
      const game_name = this.user_info?.pc_state?.game?.game_name || ''
      if(!game_name) {
        this.gameDisplayInfo = {}
        return
      }
      // 初始化正在游玩游戏的信息
      const {data: {status, result}} = await getGameDisplayInfo({
        _notip: 1,
        game_name,
      })
      if(status === 'ok' && result.game_info) {
        this.gameDisplayInfo = result
      } else {
        this.gameDisplayInfo = {}
      }
      this.updateGameDisplayBlock()
    },
    updateGameDisplayBlock() {
      const { isInHomePage, readGameDisplay, gameDisplayInfo, needExpend } = this.gameDisplayBlockMatter
      const isEmpty = (obj) => {
        return typeof obj === 'object' && Object.keys(obj).length === 0 
      }
      let res = false
      if(isEmpty(gameDisplayInfo)) {
        res = false
      } else {
        if(isInHomePage){
          if(needExpend) {
            res = true
          } else {
            if(!readGameDisplay && needExpend) {
              res = true
            }
          }
        } else {
          res = true
        }
      }
      this.SET_IS_SHOW_GAME_DISPLAY_BLOCK(res)
    },
    handleUpdateExpend() {
      this.readGameDisplay = true
      if(!this.mouseInWrapper) { 
        this.handleMouseLeaveWrapper()
      }
    },
    async changeRecordStatus() {
      if(this._autoCloseRecordTimer) {
        clearTimeout(this._autoCloseRecordTimer)
        this._autoCloseRecordTimer = null
      }
      if(!this.isAllowRecord) {
        this.$toast.error('没有在此房间录音的权限')
        return
      }
      if (this.is_recording) {
        this.$rtc.closeVoiceRecord();
      } else {
        const info = {
          room_name: this.cur_channel_data.room_name,
          channel_name: this.cur_channel_data.channel_name,
          room_id: this.cur_channel_data.room_id,
          channel_id: this.cur_channel_data.channel_id,
        };
        const id = await this.$rtc.createVoiceRecord(info);
        this.lastRecordId = id;
        this._autoCloseRecordTimer = setTimeout(() => {
          if(this.recording_id === this.lastRecordId) {
            this.$rtc.closeVoiceRecord();
            const config = {
              title: '自动结束录制',
              desc: '已达最大时长 1小时，自动结束录制',
              icon: 'icon-toast-warn',
              iconColor: 'red',
              confirm: '查看文件',
              confirmCB: () => {
                EventBus.$dynamic('UserConfig', 'record')
                this.handleClearShowRecordOperationTip()
              }
            }
            this.handleChangeShowRecordOperationTip(true, config)
          }
          clearTimeout(this._autoCloseRecordTimer)
          this._autoCloseRecordTimer = null
        }, 60 * 60 * 1000)
      }
    },    
    handleOpenRecordFile() {
      EventBus.$dynamic("UserConfig", "record");
    },
    handleRecordStateChange(state) {
      // 频道内有用户的录音状态改变
      const t_volume = this.tip_sound_volume
      if(state) {
        this.tip_sound_control(11) && playAudio(require('_audio/record-start.mp3'), t_volume)
      } else {
        this.tip_sound_control(12) && playAudio(require('_audio/record-stop.mp3'), t_volume)
      }
    },
    handleChangeShowRecordOperationTip(showVal, config) {
      this.showRecordOperationTip = showVal
      this.recordOperationConfig = config
    },
    handleClearShowRecordOperationTip(e) {
      this.handleChangeShowRecordOperationTip(false, {
        title: '',
        desc: '',
        icon: '',
        iconColor: '',
        confirm: '',
        confirmCB: () => {},
      })
    },
    getRecordingTimeFormatStr() {
      const time = this.recordingTime
      let hour = String(parseInt(time / 60 / 60)).padStart(2, '0')
      if (hour === '00') {
        hour = ''
      }
      const min = String(parseInt(time / 60) % 60).padStart(2, '0')
      const sec = String(time % 60).padStart(2, '0')
      return (hour ? hour + ':' : '') + min + ':' + sec
    },
    handleClickSwitchPreRecord() {
      const newVal = !this.setting_data.pre_record_switch
      this.SET_SETTING_DATA_PARAM({
        pre_record_switch: newVal,
      })
      if(newVal) {
        this.$rtc.startPreAudioRecordInterval()
      } else {
        // 如果正在录音，则参数为false，避免把预录的模块清空掉
        this.$rtc.stopPreAudioRecordInterval(!this.is_recording)
      }
    },
    handleResizeChannelSideBar(width) {
      this.cptWidth = width
    },
    handleAudioChannelPanelAction(action) {
      switch(action) {
        case 'hang-up':
          this.handleHangUp()
          break
        case 'screen-share':
          this.handleCickOperate('screen')
          break
        case 'mic':
          this.handleOperate('mic')
          break
        case 'voice':
          this.handleOperate('voice')
          break
      }
    },
    async handleShowAddStrangerTip() {
      let members = this.cur_channel_data.members
      const _startChannelId = this.cur_channel_data.channel_id
      this.addFriendLock = true
      if (members) {
        const {data: {
          status,
          result
        }} = await checkIsFriends({}, {
          user_ids: members.map(member => member.user_id)
        })
        if(status === 'ok' && _startChannelId === this.cur_channel_data.channel_id) {
          const { is_friends } = result
          let channelStrangers = members.filter(member => !(is_friends ?? []).includes(member.user_id) && member.user_id != this.user_info.user_id)
          this.channelStrangers = channelStrangers
          if (channelStrangers.length > 0) {
            let strangersStr = channelStrangers.slice(0, 5).map(member => member.nickname).join('、') + (channelStrangers.length > 5 ? `等${channelStrangers.length}人` : '')
            let strangersNum = channelStrangers.length
            let dom = document.querySelector(`.channel-title-${this.cur_channel_data.channel_id}`)
            if(dom) {
              let { top, bottom } = dom.getBoundingClientRect()
              let pos = {
                top,
                bottom,
                left: 66 + this.channel_sidebar_width
              }
              let config = {
                title: '一键添加当前频道内好友',
                icon: 'icon-friends-beckon',
                confirm: {
                  text: '一键添加',
                  func: this.addAllChannelFriends,
                },
                cancel: {
                  text: '取消',
                  func: () => {
                    reportData('click:add-channel-friends', {
                      type: "cancel",
                    })
                  }
                },
                click_text: {
                  text: '不再显示',
                  func: () => {
                    this.SET_SETTING_DATA_PARAM({
                      never_show_add_channel_friends: !this.setting_data.never_show_add_channel_friends
                    })
                  }
                },
                pos,
              }
              if (channelStrangers.length > 5) {
                config.text = `添加 <span>${strangersStr}</span> 等 ${strangersNum} 位成员为好友 组队开黑不丢失`
              } else {
                config.text = `添加 <span>${strangersStr}</span> 为好友 组队开黑不丢失`
              }
              reportData('exposure:add-channel-friends')
              EventBus.$dynamic('CommonTipPopover', config)
            }
          }
        }
      }
    },
    // 处理主持人模式静音
    async handleCheckHostModeBanned(target_channel) {
      const isUseHostMode = Boolean(target_channel.host_mode)
      const targetHosts = this.hosts
      const isMeInHosts = targetHosts.some(hostId => hostId == this.user_info.user_id)
      
      // 根据新数据计算出来的静音状态
      const newHostsModeBanned = isUseHostMode && !isMeInHosts
      
      // RTC中ClientData的静音状态
      const rtcClientData = this.$rtc.clientData
      const settedHostModeBanned = rtcClientData.isHostModeBanned

      const hasChange = newHostsModeBanned !== settedHostModeBanned
      if(hasChange) {
        await this.$rtc.handleHostModeBannedChange(newHostsModeBanned)
      }

      // 如果新旧数据的host_mode有区别, 并且新数据里面没有用host模式 直接清空hosts
      if(rtcClientData.host_mode != isUseHostMode && !isUseHostMode) {
        this.SET_CHANNEL_HOSTS([])
      }
    },
    causeNoiseTipFormatter,
  },
}
</script>

<style lang="scss">
.cpt-voice-panel {
  // max-height: 124px;
  .voice-panel-container {
    position: relative;
    background: $d-fl-ip;
  }
  &.custom {
    width: 240px;
    padding: 0;
  }


  &.in-home-page{
    width: 56px;
    left: 82px;
    bottom: 16px;
    border-radius: 8px;
    box-shadow: 0px 3px 15px 0px rgba(0, 0, 0, 0.35);
    .cpt-act-wrapper{
      display: none;
    }
    .voice-panel-container{
      border-radius: 8px;
      box-shadow: 0px 3px 15px 0px rgba(0, 0, 0, 0.35);
    }
    .guide-enter-audio-channel-btn{
      bottom: 36px;
      left: 53px;
      &.use-minimal-guide{
        bottom: 36px;
        left: 53px;
      }
    }
    .user-card-guide{
      left: 35px !important;
      bottom: 35px !important;
    }
    .record-operation-tip {
      bottom: 125px !important;
    }
    &.module-expend{
      width: fit-content;
      left: 82px;
      bottom: 16px;
      height: auto;
      .guide-enter-audio-channel-btn{
        left: 50%;
        bottom: 124px;
        &.use-minimal-guide{
          bottom: 120px;
          left: 68%;
        }
      }
      .user-card-guide{
        left: 81px !important;
        bottom: 18px !important;
      }
      .cpt-act-wrapper{
        display: block;
      }
      .addition-operate{
        .operate-block{
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
      &.module-expend-animation {
        animation-name: big-scale;
        animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
        animation-duration: 300ms;
        animation-fill-mode: forwards;
      }
      &.module-collapse-animation {
        animation-name: small-scale;
        animation-delay: 140ms;
        animation-duration: 160ms;
        animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
        animation-fill-mode: forwards;
      }
    }
    &.has-top-panel{
      .voice-panel-container{
        border-radius: 0 0 8px 8px;
        box-shadow: none;
      }
    }
    .avatar-container{
      height: 56px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .channel-audio-state{
      height: 64px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 4px;
      border-radius: 8px;
      > .icon-dial{
        font-size: 22px;
        color: $d-bd-tx;
      }
      > .audio-remain-state{
        color: $d-bd-tx;
        text-align: center;
        font-family: Roboto;
        font-size: 13px;
        font-weight: 500;
      }
    }
  }

  .custom-img {
    display: none;
  }

  .user-card-guide {
    z-index: 10;
    bottom: 18px;
  }

  .mask {
    height: 50px;
    width: 100%;
    background: linear-gradient(transparent 0%, $d-fl-1-50 100%);
    position: absolute;
    top: -50px;
    left: 0px;
    pointer-events: none;
  }

  .room-info {
    .left {

      p {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 180px;
      }

      .cpt-chat-circle-loading {
        margin-right: 4px;
      }

      .connect-state {

        &.signal-1 {
          color: $d-bd-tx;

          .reg {
            background: $d-bd-tx !important;
          }
        }

        &.signal-2 {
          color: $d-wn-tx;

          .r1,
          .r2 {
            background: $d-wn-tx !important;
          }
        }

        &.signal-3 {
          color: $d-er-tx;

          .r1 {
            background: $d-er-tx !important;
          }
        }

        .signal {
          width: 14px;
          height: 14px;
          margin-right: 4px;
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          flex-shrink: 0;

          .reg {
            width: 4px;
            background: $d-op-2;
            border-radius: 1px;

            &.r1 {
              height: 5px;
            }

            &.r2 {
              height: 9px;
            }

            &.r3 {
              height: 14px;
            }
          }
        }

        .time-remain {
          font-family: 'Roboto';
          flex-shrink: 0;
        }
      }

    }

    .hangup {
      background: $d-er-fl;
    }
    .minimal {
      background: $d-op-3;
    }
    .hangup,
    .minimal {
      width: 26px;
      height: 26px;
      flex-shrink: 0;
      margin-left: 8px;
      border-radius: 3px;
      cursor: pointer;

      i {
        width: 26px;
        height: 26px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;

        &:hover {
          background: $d-op-2;
          border-radius: 3px;
        }

        &::before {
          width: 18px;
          height: 18px;
          font-size: 18px;
        }
      }
    }

    .icon-hangup {
      margin-right: 1px;
    }
  }

  .addition-operate {
    height: 42px;
    margin-right: -8px;
    padding-bottom: 3px;
    display: flex;
    align-items: flex-end;
    position: relative;
    .cpt-get-screen-share-tips {
      &::after {
        content: '';
        width: 22px;
        height: 6px;
        background: url('@/assets/images/triangle.svg') no-repeat center / cover;
        position: absolute;
        bottom: -6px;
        left: 118px;
      }
      .avatar-box {
        position: relative;
        &::before, &::after {
          content: '';
          width: 11px;
          height: 18px;
          background: url('@/assets/images/star2.png') no-repeat center / cover;
          position: absolute;
        }
        &::before {
          left: -29px;
          top: 48px;
        }
        &::after {
          right: -23px;
          top: 17px;
        }
      }
      .cpt-user-avatar {
        width: 74px;
        height: 74px
      }
    }
  .cpt-record-guide-tip {
      &::after {
        content: '';
        width: 22px;
        height: 6px;
        background: url('@/assets/images/white-triangle.svg') no-repeat center / cover;
        position: absolute;
        bottom: -6px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    .operate-block {
      margin-right: 8px;
      height: 30px;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      background-color: $d-op-1;
      position: relative;
      cursor: pointer;

      i,
      img {
        width: 18px;
        height: 18px;
        margin-right: 6px;
        font-size: 18px;
        color: $d-tx-2;
      }

      img {
        border-radius: 50%;
      }

      span {
        font-size: 12px;
        font-weight: 400;
        line-height: 30px;
        color: $d-op-4;
      }

      &.only-icon {
        width: 30px;
        flex: unset;

        i {
          margin-right: 0;
        }
      }

      &.bgm-active {

        i,
        img {
          animation: rotate 6s infinite linear;
          margin-right: 0;
        }

        span {
          font-weight: 700;
          color: $d-tx-1;
        }
      }

      &.screen-active {
        background-color: $d-op-3;

        i,
        span {
          font-weight: 700;
          color: $d-tx-1;
        }
      }

      &.laughter-active {

        i,
        span {
          font-weight: 700;
          color: $d-tx-1;
        }
      }

      &.screen-active {

        i,
        span {
          font-weight: 700;
          color: $d-tx-1;
        }
      }

      &.disabled {
        cursor: not-allowed;

        i {
          color: $d-op-3;
        }
      }

      &.icon-flash {
        animation: flash 2.4s ease-in-out infinite forwards;
      }

      &.record-active {
        animation: record-fade 12s cubic-bezier(0, 0, 0.58, 1) infinite alternate;
        & > i {
          color: $d-er-tx;
        }
      }
    }

    .beta-tip {
      margin: 0;
      position: absolute;
      left: 80px;
      bottom: 26px;
      transform: scale(.72);
      transform-origin: left bottom;
      pointer-events: none;
    }
    .bgm-hook-warn-tip {
      position: absolute;
      bottom: 37px;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .room-name {
    margin-top: 6px;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.01em;
    color: $d-tx-2;
    cursor: pointer;
    display: flex;
    align-items: center;

    span {
      max-width: 165px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    i {
      width: 6px;
      height: 6px;
      margin-left: 4px;

      &::before {
        width: 12px;
        height: 12px;
        font-size: 12px;
        transform: scale(.5);
        color: $d-tx-2;
        transform-origin: left top;
      }
    }

    &:hover span {
      text-decoration: underline;
    }
  }

  .split {
    width: 100%;
    height: 1px;
    background: $d-op-2;
    margin: 9px 0 -2px;
  }

  .top-wrapper {
    padding: 13px 16px 0;
    &.only-text-wrapper {
      display: flex;
      align-items: center;
      padding: 13px 16px;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 16px;
        right: 16px;
        height: 1px;
        background: $d-op-2;
      }
      .channel-info {
        flex: 1;
        width: 0;
        margin-right: 10px;
        .channel-name {
          color: $d-tx-1;
          font-size: 14px;
          font-weight: 700;
          line-height: 18px;
          letter-spacing: 0.14px;
        }
        .audio-member-count {
          margin-top: 6px;
          padding-bottom: 2px;
          color: $d-op-4;
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
          letter-spacing: 0.12px;
        }
      }
      .join-channel-btn {
        width: 69px;
        height: 30px;
        font-size: 12px;
        font-weight: 700;
        line-height: 16px;
        letter-spacing: 0.12px;
      }
    }
  }

  .bottom-wrapper {

    .user-info {

      .user-text {

        p {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          max-width: 90px;
        }

        .state {
          font-weight: 400;
          font-size: 10px;
          line-height: 14px;
          letter-spacing: 0.01em;
          color: $d-tx-3;
          max-width: 100px;

          &.online {
            color: $d-ol-tx;
          }

          &.other-state {
            color: $d-op-4;
          }
        }

        .hover-roll {
          position: relative;

          p {
            transition: all .22s ease;
            transform-style: preserve-3d;
            user-select: none;
            pointer-events: none;
          }

          .hover-text {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            transform: translate3d(0, 107%, 0);
            opacity: 0;
          }

          .default-text .game-state {
            opacity: .7;
          }
        }
      }

      .operation-setting {
        position: absolute;
        left: -5px;
        bottom: 35px;
        padding-bottom: 15px;
      }

      &:hover {
        .user-text .hover-roll {
          .hover-text {
            transform: translatez(0);
            opacity: 1;
          }

          .default-text {
            transform: translate3d(0, -107%, 0);
            opacity: 0;
          }
        }

      }
    }

    .track-wrapper {

      .icon-container {
        position: relative;
        // width: 26px;
        height: 34px;
        margin: -5px 0 -5px 4px;
        display: flex;
        align-items: center;

        &:first-of-type {
          margin-left: 0;
        }

        .icon-mic-missing,
        .icon-mic-off,
        .icon-mic-locked,
        .icon-speak-off {
          color: $d-er-tx;
        }
      }

      .icon {
        height: 26px;
        padding: 0 4px;
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        position: relative;

        &:hover {
          &::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background: $d-op-1;
            z-index: 1;
            pointer-events: none;
            border-radius: 2px;
          }

        }
      }

      i,
      svg {
        color: $d-op-5;
        width: 18px;
        height: 18px;
        font-size: 18px;

        &.mute-svg {
          path {
            fill: $d-op-5;

            &.error-line {
              fill: $d-er-tx;
            }
          }
        }
      }

      .mic-icon {
        width: 18px;
        height: 18px;
        position: relative;
        overflow: hidden;

        img,
        i,
        div {
          width: 18px;
          height: 18px;
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
        }

        svg {
          width: 26px;
          height: 26px;
          position: absolute;
          top: -4px;
          left: -4px;

          path {
            fill: $d-fl-ip;
          }
        }

        .gray {
          background: $d-op-5;
        }

        .green {
          height: 0px;
          background: $d-bd-tx;
        }
      }

      .mic-icon,
      .ai-icon {
        width: 18px;
        height: 18px;
        position: relative;
        overflow: hidden;

        img,
        i,
        div {
          width: 18px;
          height: 18px;
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
        }
      }

      .ai-icon {
        .ln-bg {
          width: 100px;
          background: $d-lk-1;
          animation: leftmove 3s linear infinite paused;
        }
        .cl-bg {
          width: 100%;
          background: $d-op-5;
        }

        svg {
          width: 26px;
          height: 26px;
          position: absolute;
          top: -4px;
          left: -4px;

          path {
            fill: $d-fl-ip;
          }
        }
      }

      .close-mic-state-tip {
        height: 30px;
        bottom: 30px;
        left: -26px;

        &::after {
          content: '';
          position: absolute;
          border-top: 6px #fff solid;
          border-left: 6px transparent solid;
          border-right: 6px transparent solid;
          bottom: -6px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }

    &:hover {
      .ai-icon .ln-bg {
        animation: leftmove 3s linear infinite running;
      }
    }
  }

  .guide-enter-audio-channel-btn {
    position: absolute;
    transform: translateX(-50%);
    bottom: 120px;
    left: 50%;
    width: 46px;
    height: 46px;
    display: flex;
    justify-content: center;
    align-items: center;
    &.use-minimal-guide{
      bottom: 120px;
      left: 68%;
    }
    .cpt-poping-icon {
      position: static;
    }

    .trigger-click-area {
      width: 240px;
      height: 104px;
      position: absolute;
      top: 6px;
      left: -97px;
      cursor: pointer;
    }
  }
  .cpt-bgm-selector {
    position: fixed;
    bottom: 107px;
    left: 222px;
  }
  .record-operation-info-icon {
    &.red {
      & > .iconfont {
        color: $d-er-tx
      }
    }
    &.yellow {
      & > .iconfont {
        color: $d-wn-tx
      }
    }
    &.green {
      & > .iconfont {
        color: $d-bd-tx
      }
    }
    & > .iconfont {
      width: 22px;
      height: 22px;
      font-size: 22px;
    }
  }
}
.operation-setting {
  width: 224px;
  padding: 8px;
  background: $d-fl-pp;
  border: 1px solid $d-op-1;
  box-shadow: 0px 2px 13px rgba(0, 0, 0, 0.07);
  position: absolute;
  bottom: 34px;
  left: 0;
  border-radius: 8px;
  &.ai-denoiser-setting{
    width: 188px;
  }
  .cpt-radio-row {
    padding: 0 8px;
    cursor: pointer;
    .radio-icon {
      color: $d-op-4;
    }

    &:hover {
      .arrow-menu-icon {
        color: $ct-wh-0 !important;
      }
      .radio-icon {
        color: $d-tx-1;
      }
      .icon-log-in-heybox {
        color: $ct-wh-0 !important;
      }
      .icon-add-circle{
        color: $ct-wh-0 !important;
      }
    }
  }

  .block {
    position: relative;

    &:not(:first-of-type) {
      margin-top: 13px;

      &::after {
        content: '';
        height: 1px;
        background: $d-op-1;
        position: absolute;
        top: -7px;
        left: 0;
        right: 0;
      }
    }

    .title {
      height: 30px;
      padding: 0 8px;
      padding-top: 2px;
      font-weight: 700;
      font-size: 12px;
      line-height: 36px;
      letter-spacing: 0.01em;
      color: $d-tx-3;
      margin-bottom: 4px;
    }

    .row {
      width: 100%;
      // height: 32px;
      font-weight: 400;
      font-size: 14px;
      line-height: 32px;
      letter-spacing: 0.01em;
      color: $d-tx-2;
      cursor: pointer;
      padding: 0 8px;

      &:hover {
        background: $d-op-1;
        border-radius: 5px;
      }

      &.red {
        color: $d-er-tx;
      }

      &.active {
        .radio {
          border: 2px solid $d-bd-tx !important;
          position: relative;

          &::after {
            content: '';
            position: absolute;
            width: 8px;
            height: 8px;
            left: 2px;
            top: 2px;
            background: $d-bd-tx;
            border-radius: 50%;
          }
        }
      }

      .text {
        width: 100%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      &.switch-row {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .text {
          width: calc(100% - 32px);
        }

        .radio {
          width: 16px;
          height: 16px;
          border: 2px solid $d-op-2;
          border-radius: 50%;
        }

        .switch {
          width: 26px;
          height: 16px;
        }
      }

      &.icon-row {
        display: flex;
        align-items: center;

        i {
          color: $d-tx-2;
          width: 16px;
          height: 16px;
          font-size: 16px;
          margin-right: 6px;
        }
      }

      &.ai-row {
        display: block;
        .switch-ai {
          @include flex(row, flex-start, center);
        }
      }


      .icon-arrow-left {
        width: 6px;
        height: 6px;
        font-size: 12px;
        color: $d-tx-3;
        &::before {
          transform: scale(.5);
          transform-origin: left top;
        }
      }

      .text-block {
        flex: 1;
        width: 0;
        padding: 6px 0;

        .text {
          width: 100%;
          line-height: 18px;
          color: $d-tx-2;
        }

        .desc {
          line-height: 20px;
          color: $d-op-4;
        }
      }
      .ai-denoiser-version-menu, .ai-denoiser-type-menu {
        @import '_css/context_menu.scss';
        padding-left: 8px;
        width: 196px;
        position: absolute;
        .menu-container {
          width: 100%;
          padding: 8px 0 8px 8px;
          position: unset;
        }
      }
      .ai-denoiser-version-menu {
        position: absolute;
        top: 0;
        left: 176px;
        .cpt-radio-row.highlight{
          background: $d-bd-fl;
          color: $ct-wh-0;
          border-radius: 5px;
          .radio{
            border: 2px solid $ct-wh-0!important;
            &::after {
              background: $ct-wh-0 !important;
            }
          }
          .icon-arrow-left{
            color: $ct-wh-0;
          }
        }
      }
      .ai-denoiser-type-menu {
        position: absolute;
        top: 40px;
        left: 368px;
      }

      .left-icon {
        margin-right: 6px;
      }
    }

    .slider-row {
      height: 64px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      padding: 0 8px;
      width: 208px;

      .row-1 {
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 0.01em;
        color: $d-tx-2;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 6px;

        i,
        svg {
          margin-left: auto;
          width: 16px;
          height: 16px;
          cursor: pointer;
          font-size: 16px;
        }
      }
    }

    .split {
      background: $d-op-1;
    }
    .cpt-radio-row {
      &:hover {
        background: $d-bd-fl;
        color: $ct-wh-0;
        border-radius: 5px;
        .radio {
          border: 2px solid $ct-wh-0!important;
          &::after {
            background: $ct-wh-0 !important;
          }
        }
      }
    }
  }

  .weak-text {
    width: 100%;
    padding-bottom: 6px;
    color: $d-tx-3;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
    letter-spacing: 0.12px;
  }
}

.refuse-audio-dialog {
  .cancel {
    width: 131px!important;
  }
}

@keyframes leftmove {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(calc(-100% + 18px));
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes flash {
  0% {
    opacity: 1;
  }

  50% {
    opacity: .6;
  }

  100% {
    opacity: 1;
  }
}

.bgm-selector {
  position: fixed;
  bottom: 107px;
  left: 82px;
}

.pannel-av-line-icon {
  margin-left: 5px;
  flex-shrink: 0;
}

@keyframes big-scale {
  0% {
    transform-origin: left bottom;
    transform: scale(0.93);
  }
  100% {
    transform-origin: left bottom;
    transform: scale(1);
  }
}

@keyframes small-scale {
  0% {
    transform-origin: left bottom;
    transform: scale(1);
  }
  100% {
    transform-origin: left bottom;
    transform: scale(0.93);
  }
}
@keyframes record-fade {
  0% {
    background-color: var(--opacity-3);
  }
  100% {
    background-color: var(--opacity-3-6);
  }
}
</style>
<style lang="scss">
.network-stats-tooltip {
  color: $d-tx-2;
  line-height: 24px;
  border-radius: 5px;

  &.stats-1 span {
    color: $d-bd-tx;
  }

  &.stats-2 span {
    color: $d-wn-tx;
  }

  &.stats-3 span {
    color: $d-er-tx;
  }
}

.cpt-tooltip {
  & >.record-tooltip {
    .record-tooltip-title {
      min-width: 117px;
      color: $d-tx-2;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.14px;
      text-align: center;
      white-space: nowrap;
    }
    .record-tooltip-desc {
      color: $d-tx-3;
      text-align: center;
      font-size: 12px;
      line-height: 18px;
      letter-spacing: 0.12px;
    }
  }
}

.record-popover-panel {
  .checkbox {
    min-width: 16px;
    margin-left: auto;
    width: 16px;
    height: 16px;
    border-radius: 2px;
    border: 2px solid $d-op-2;
    position: relative;
    i {
      width: 16px;
      height: 16px;
      font-size: 16px;
      color: $d-bd-tx;
      position: absolute;
      left: -1px;
      top: -1px;
    }
  }
  .row {
    &:hover {
      color: $ct-wh-0;
      .left{
        color: $ct-wh-0;
      }
      .iconfont {
        color: $ct-wh-0;
      }
    }
  }
}
</style>